(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["agency-client-logos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('agency-logo-marquee')) {
    customElements.define(
      'agency-logo-marquee',
      class AgencyLogoMarquee extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-logo-track]');
          this.group = this.querySelector('[data-logo-group]');
          if (!this.track || !this.group) return;

          this.baseSpeed = Number(this.dataset.speed) || 78;
          this.hoverSpeed = Number(this.dataset.hoverSpeed) || 25;
          this.direction = this.dataset.direction === 'right' ? 'right' : 'left';
          this.currentSpeed = this.baseSpeed;
          this.targetSpeed = this.baseSpeed;
          this.offset = 0;
          this.loopDistance = 0;
          this.lastTime = 0;
          this.frame = null;
          this.isVisible = false;
          this.isDocumentVisible = !document.hidden;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

          this.measure = this.measure.bind(this);
          this.tick = this.tick.bind(this);
          this.handleVisibility = this.handleVisibility.bind(this);
          this.handleMotionPreference = this.handleMotionPreference.bind(this);
          this.slow = () => {
            this.targetSpeed = this.hoverSpeed;
          };
          this.resume = () => {
            this.targetSpeed = this.baseSpeed;
          };

          this.resizeObserver = new ResizeObserver(this.measure);
          this.resizeObserver.observe(this.group);

          this.intersectionObserver = new IntersectionObserver((entries) => {
            this.isVisible = entries[0]?.isIntersecting || false;
            this.updatePlayback();
          });
          this.intersectionObserver.observe(this);

          this.addEventListener('pointerenter', this.slow);
          this.addEventListener('pointerleave', this.resume);
          document.addEventListener('visibilitychange', this.handleVisibility);
          this.reducedMotion.addEventListener('change', this.handleMotionPreference);
          this.measure();
        }

        disconnectedCallback() {
          this.stop();
          this.resizeObserver?.disconnect();
          this.intersectionObserver?.disconnect();
          this.removeEventListener('pointerenter', this.slow);
          this.removeEventListener('pointerleave', this.resume);
          document.removeEventListener('visibilitychange', this.handleVisibility);
          this.reducedMotion?.removeEventListener('change', this.handleMotionPreference);
        }

        measure() {
          const trackStyles = getComputedStyle(this.track);
          const trackGap = parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
          const nextDistance = this.group.getBoundingClientRect().width + trackGap;
          if (nextDistance <= 0) return;

          const progress = this.loopDistance > 0 ? this.offset / this.loopDistance : 0;
          this.loopDistance = nextDistance;
          this.offset = progress * this.loopDistance;
          this.render();
        }

        handleVisibility() {
          this.isDocumentVisible = !document.hidden;
          this.updatePlayback();
        }

        handleMotionPreference() {
          this.offset = 0;
          this.render();
          this.updatePlayback();
        }

        updatePlayback() {
          if (this.isVisible && this.isDocumentVisible && !this.reducedMotion.matches) {
            this.start();
          } else {
            this.stop();
          }
        }

        start() {
          if (this.frame) return;
          this.lastTime = performance.now();
          this.frame = requestAnimationFrame(this.tick);
        }

        stop() {
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = null;
          this.lastTime = 0;
        }

        tick(time) {
          const elapsed = Math.min(time - this.lastTime, 64);
          this.lastTime = time;
          const easing = 1 - Math.exp(-elapsed / 280);
          this.currentSpeed += (this.targetSpeed - this.currentSpeed) * easing;

          if (this.loopDistance > 0) {
            this.offset = (this.offset + (elapsed / 1000) * this.currentSpeed) % this.loopDistance;
            this.render();
          }

          this.frame = requestAnimationFrame(this.tick);
        }

        render() {
          const translateX = this.direction === 'right' ? this.offset - this.loopDistance : -this.offset;
          this.track.style.transform = `translate3d(${translateX}px, 0, 0)`;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agency-client-testimonial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('agency-client-testimonial')) {
    customElements.define('agency-client-testimonial', class extends HTMLElement {
      connectedCallback() {
        this.quote = this.querySelector('.agency-client-testimonial__quote');
        if (!this.quote) return;

        this.scheduleFit = () => {
          cancelAnimationFrame(this.fitFrame);
          this.fitFrame = requestAnimationFrame(() => this.fitQuote());
        };
        this.lastWidth = null;
        this.resizeObserver = new ResizeObserver(([entry]) => {
          if (entry.contentRect.width === this.lastWidth) return;
          this.lastWidth = entry.contentRect.width;
          this.scheduleFit();
        });
        this.resizeObserver.observe(this.quote);
        this.contentObserver = new MutationObserver(this.scheduleFit);
        this.contentObserver.observe(this.quote, { childList: true, characterData: true, subtree: true });
        document.fonts.ready.then(() => {
          if (this.isConnected) this.scheduleFit();
        });
        this.scheduleFit();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.fitFrame);
        this.resizeObserver?.disconnect();
        this.contentObserver?.disconnect();
      }

      fitQuote() {
        if (!this.isConnected || !this.quote.clientWidth) return;
        const paragraphs = [...this.quote.querySelectorAll('p')];
        this.quote.style.removeProperty('--agency-testimonial-quote-size');
        const maximum = parseFloat(getComputedStyle(this.quote).fontSize);
        const lineCount = () => paragraphs.reduce((total, paragraph) => {
          const leading = parseFloat(getComputedStyle(paragraph).lineHeight);
          return total + Math.round(paragraph.getBoundingClientRect().height / leading);
        }, 0);
        if (lineCount() <= 5) return;

        // Fit the complete quote, including both paragraphs, without hiding words.
        let lower = 1;
        let upper = maximum;
        for (let step = 0; step < 10; step += 1) {
          const candidate = (lower + upper) / 2;
          this.quote.style.setProperty('--agency-testimonial-quote-size', `${candidate}px`);
          if (lineCount() <= 5) lower = candidate;
          else upper = candidate;
        }
        this.quote.style.setProperty('--agency-testimonial-quote-size', `${Math.floor(lower * 10) / 10}px`);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agency-review-highlights"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tagName = 'agency-review-highlights';
  if (!window.customElements || customElements.get(tagName)) return;

  const scrollLocks = new Set();
  let bodyOverflow;

  class AgencyReviewHighlights extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      const connection = (this._connection || 0) + 1;
      this._connection = connection;
      queueMicrotask(() => {
        if (this._connected && this._connection === connection) this._setup(connection);
      });
    }

    _setup(connection) {
      this._grid = this.querySelector('[data-review-grid]');
      if (!this._grid) return;
      this._crop = this.querySelector('[data-review-crop]');
      this._cards = Array.from(this._grid.children).filter((card) => card.matches('[data-review-card]'));
      this._slideCurrent = this.querySelector('[data-review-slide-current]');
      this._slidePrevious = this.querySelector('[data-review-slide-direction="-1"]');
      this._slideNext = this.querySelector('[data-review-slide-direction="1"]');
      this._currentSlide = 0;
      this._isSlider = false;
      this._dialog = this.querySelector('[data-review-dialog]');
      this._dialogTitle = this.querySelector('[data-review-dialog-title]');
      this._dialogContent = this.querySelector('[data-review-dialog-content]');
      this._abort = new AbortController();
      const options = { signal: this._abort.signal };
      this._originalGrid = {
        height: this._grid.style.getPropertyValue('height'),
        priority: this._grid.style.getPropertyPriority('height'),
        layoutReady: this._grid.getAttribute('data-layout-ready'),
      };
      this._originalCards = new Map(this._cards.map((card) => [card, {
        left: card.style.getPropertyValue('left'),
        leftPriority: card.style.getPropertyPriority('left'),
        top: card.style.getPropertyValue('top'),
        topPriority: card.style.getPropertyPriority('top'),
        inert: card.hasAttribute('inert'),
        snippetLines: card.style.getPropertyValue('--review-snippet-lines'),
        snippetLinesPriority: card.style.getPropertyPriority('--review-snippet-lines'),
      }]));
      this._originalEditorExpanded = this.getAttribute('data-editor-expanded');
      this._resizeSizes = new WeakMap();

      this.addEventListener('click', (event) => this._handleClick(event), options);
      this._grid.addEventListener('scroll', () => {
        if (this._isSlider) this._schedule();
      }, { ...options, passive: true });
      this.addEventListener('load', (event) => {
        if (event.target instanceof HTMLImageElement && this._grid.contains(event.target)) this._schedule();
      }, { ...options, capture: true });
      this.addEventListener('error', (event) => {
        if (event.target instanceof HTMLImageElement && this._grid.contains(event.target)) this._schedule();
      }, { ...options, capture: true });
      window.addEventListener('resize', () => this._schedule(), options);
      document.addEventListener('shopify:block:select', (event) => this._selectBlock(event), options);
      document.addEventListener('shopify:block:deselect', (event) => this._deselectBlock(event), options);

      if (this._dialog) {
        this._dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this._closeReview();
        }, options);
        this._dialog.addEventListener('close', () => {
          if (!this._dialog.open) this._finishClose();
        }, options);
        this._dialog.addEventListener('click', (event) => {
          if (event.target !== this._dialog || event.detail === 0) return;
          const rect = this._dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right ||
              event.clientY < rect.top || event.clientY > rect.bottom) this._closeReview();
        }, options);
      }

      if ('ResizeObserver' in window) {
        this._resizeObserver = new ResizeObserver((entries) => {
          let changed = false;
          for (const entry of entries) {
            const size = [entry.contentRect.width, entry.target === this._grid ? 0 : entry.target.offsetHeight];
            const previous = this._resizeSizes.get(entry.target);
            if (!previous || previous[0] !== size[0] || previous[1] !== size[1]) changed = true;
            this._resizeSizes.set(entry.target, size);
          }
          if (changed) this._schedule();
        });
        this._resizeObserver.observe(this._grid);
        if (this._crop && this._crop !== this._grid) this._resizeObserver.observe(this._crop);
        this._cards.forEach((card) => this._resizeObserver.observe(card));
      }

      if (document.fonts) {
        document.fonts.addEventListener('loadingdone', () => this._schedule(), options);
      }
      this._schedule();
    }

    _schedule() {
      if (!this._connected || !this._grid || this._frame) return;
      this._frame = requestAnimationFrame(() => {
        this._frame = 0;
        if (this._connected) this._layout();
      });
    }

    _layout() {
      if (this._grid.clientWidth <= 0) return;
      this._isSlider = window.matchMedia('(max-width: 749px)').matches;
      if (this._isSlider) {
        this._grid.style.removeProperty('height');
        this._grid.removeAttribute('data-layout-ready');
        this._cards.forEach((card) => {
          card.style.removeProperty('left');
          card.style.removeProperty('top');
        });
        if (this._scrollToCard) {
          const card = this._scrollToCard;
          this._scrollToSlide(this._cards.indexOf(card), 'auto');
          this._updateSlider();
          card.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'auto' });
          this._scrollToCard = null;
        }
        this._updateSlider();
        return;
      }
      this._cards.forEach((card) => card.style.removeProperty('--review-snippet-lines'));
      this._grid.setAttribute('data-layout-ready', '');
      const styles = getComputedStyle(this._grid);
      const columns = Math.max(1, Math.floor(parseFloat(styles.getPropertyValue('--review-columns')) || 1));
      const gap = Math.max(0, parseFloat(styles.getPropertyValue('--review-gap')) || 0);
      const columnWidth = (this._grid.clientWidth - gap * (columns - 1)) / columns;
      const heights = this._cards.map((card) => card.offsetHeight);
      const columnHeights = Array(columns).fill(0);

      this._cards.forEach((card, index) => {
        let column = 0;
        for (let candidate = 1; candidate < columns; candidate += 1) {
          if (columnHeights[candidate] < columnHeights[column]) column = candidate;
        }
        card.style.left = `${column * (columnWidth + gap)}px`;
        card.style.top = `${columnHeights[column]}px`;
        columnHeights[column] += heights[index] + gap;
      });
      this._grid.style.height = `${Math.max(0, ...columnHeights) - (this._cards.length ? gap : 0)}px`;
      this._updateInert();
      if (this._scrollToCard) {
        const card = this._scrollToCard;
        this._scrollToCard = null;
        card.scrollIntoView({ block: 'center', behavior: 'auto' });
      }
    }

    _updateSlider() {
      const start = this._grid.getBoundingClientRect().left;
      let nearest = 0;
      let distance = Infinity;
      this._cards.forEach((card, index) => {
        const candidate = Math.abs(card.getBoundingClientRect().left - start);
        if (candidate < distance) {
          nearest = index;
          distance = candidate;
        }
      });
      this._currentSlide = nearest;
      this._cards.forEach((card) => {
        const snippet = card.querySelector('.agency-review-highlights__snippet');
        if (!snippet) return;
        const lineHeight = parseFloat(getComputedStyle(snippet).lineHeight);
        const lines = Math.max(1, Math.floor(snippet.getBoundingClientRect().height / lineHeight));
        card.style.setProperty('--review-snippet-lines', String(lines));
      });
      if (this._slideCurrent) this._slideCurrent.textContent = String(nearest + 1);
      if (this._slidePrevious) this._slidePrevious.disabled = nearest === 0;
      if (this._slideNext) this._slideNext.disabled = nearest >= this._cards.length - 1;
      this._updateInert();
    }

    _scrollToSlide(index, behavior) {
      const card = this._cards[Math.max(0, Math.min(this._cards.length - 1, index))];
      if (!card) return;
      this._grid.scrollTo({
        left: card.offsetLeft,
        behavior: behavior || (window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'),
      });
    }

    _updateInert() {
      if (this._isSlider) {
        this._cards.forEach((card, index) => {
          card.inert = this._originalCards.get(card).inert || index !== this._currentSlide;
        });
        return;
      }
      const expanded = Boolean(window.Shopify && window.Shopify.designMode) || this.hasAttribute('data-editor-expanded');
      const cropBounds = !expanded && this._crop ? this._crop.getBoundingClientRect() : null;
      const threshold = cropBounds ? cropBounds.bottom - 120 : Infinity;
      for (const card of this._cards) {
        const originallyInert = this._originalCards.get(card).inert;
        const trigger = card.querySelector('button[data-review-open]');
        const control = trigger && (trigger.querySelector('.agency-review-highlights__play') || trigger);
        const bounds = (control || card).getBoundingClientRect();
        const controlClipped = Boolean(cropBounds) && (bounds.top < cropBounds.top || bounds.bottom > threshold);
        card.inert = originallyInert || controlClipped;
      }
    }

    _handleClick(event) {
      if (!(event.target instanceof Element)) return;
      const direction = event.target.closest('[data-review-slide-direction]');
      if (direction && direction.closest(tagName) === this && this._isSlider) {
        event.preventDefault();
        this._scrollToSlide(this._currentSlide + Number(direction.dataset.reviewSlideDirection));
        return;
      }
      const close = event.target.closest('[data-review-dialog-close]');
      if (close && close.closest(tagName) === this) {
        event.preventDefault();
        this._closeReview();
        return;
      }
      const trigger = event.target.closest('button[data-review-open]');
      if (!trigger || trigger.closest(tagName) !== this) return;
      event.preventDefault();
      this._openReview(trigger);
    }

    _openReview(trigger) {
      if (!this._dialog || !this._dialogContent || !this._dialogTitle ||
          typeof this._dialog.showModal !== 'function' || this._dialog.open) return;
      const template = Array.from(this.querySelectorAll('template[data-review-template]')).find((item) =>
        item.dataset.reviewTemplate === trigger.dataset.reviewOpen && item.closest(tagName) === this);
      if (!template) return;
      this._dialogContent.replaceChildren(template.content.cloneNode(true));
      this._dialogTitle.textContent = trigger.dataset.reviewTitle || 'Client review';
      this._returnFocus = trigger;
      this._lockScroll();
      try {
        this._dialog.showModal();
      } catch (error) {
        this._finishClose();
        return;
      }
      this._dialogTitle.focus({ preventScroll: true });
      this._dialogContent.querySelectorAll('iframe[data-src]').forEach((frame) => {
        frame.src = frame.dataset.src;
      });
      this._dialogContent.querySelectorAll('video').forEach((video) => {
        const attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
      });
    }

    _closeReview() {
      if (this._dialog && this._dialog.open) this._dialog.close();
      this._finishClose();
    }

    _finishClose(restoreFocus = true) {
      if (this._dialogContent) {
        this._dialogContent.querySelectorAll('video').forEach((video) => {
          video.pause();
          video.removeAttribute('src');
          video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
          video.load();
        });
        this._dialogContent.querySelectorAll('iframe').forEach((frame) => { frame.src = 'about:blank'; });
        this._dialogContent.replaceChildren();
      }
      this._unlockScroll();
      const trigger = this._returnFocus;
      this._returnFocus = null;
      if (restoreFocus && trigger && trigger.isConnected) trigger.focus({ preventScroll: true });
    }

    _lockScroll() {
      if (scrollLocks.has(this) || !document.body) return;
      if (!scrollLocks.size) {
        bodyOverflow = {
          element: document.body,
          value: document.body.style.getPropertyValue('overflow'),
          priority: document.body.style.getPropertyPriority('overflow'),
        };
        document.body.style.setProperty('overflow', 'hidden');
      }
      scrollLocks.add(this);
    }

    _unlockScroll() {
      if (!scrollLocks.delete(this) || scrollLocks.size || !bodyOverflow) return;
      if (bodyOverflow.value) bodyOverflow.element.style.setProperty('overflow', bodyOverflow.value, bodyOverflow.priority);
      else bodyOverflow.element.style.removeProperty('overflow');
      bodyOverflow = null;
    }

    _eventCard(event) {
      const blockId = event.detail && event.detail.blockId;
      if (blockId) return this._cards.find((card) => card.dataset.blockId === blockId);
      if (!(event.target instanceof Element)) return null;
      const card = event.target.closest('[data-review-card][data-block-id]');
      return this._cards.includes(card) ? card : null;
    }

    _selectBlock(event) {
      const card = this._eventCard(event);
      if (!card) return;
      this._selectedEditorCard = card;
      this._scrollToCard = card;
      this.setAttribute('data-editor-expanded', '');
      this._updateInert();
      this._schedule();
    }

    _deselectBlock(event) {
      if (!this._selectedEditorCard || this._eventCard(event) !== this._selectedEditorCard) return;
      this._selectedEditorCard = null;
      this._scrollToCard = null;
      this._restoreEditorExpanded();
      this._schedule();
    }

    _restoreEditorExpanded() {
      if (this._originalEditorExpanded === null) this.removeAttribute('data-editor-expanded');
      else this.setAttribute('data-editor-expanded', this._originalEditorExpanded);
    }

    disconnectedCallback() {
      this._connected = false;
      if (this._frame) cancelAnimationFrame(this._frame);
      this._frame = 0;
      if (this._abort) this._abort.abort();
      if (this._resizeObserver) this._resizeObserver.disconnect();
      if (this._dialog && this._dialog.open) this._dialog.close();
      this._finishClose(false);
      if (this._originalGrid && this._grid) {
        if (this._originalGrid.height) this._grid.style.setProperty('height', this._originalGrid.height, this._originalGrid.priority);
        else this._grid.style.removeProperty('height');
        if (this._originalGrid.layoutReady === null) this._grid.removeAttribute('data-layout-ready');
        else this._grid.setAttribute('data-layout-ready', this._originalGrid.layoutReady);
      }
      if (this._originalCards) this._originalCards.forEach((original, card) => {
        for (const property of ['left', 'top']) {
          if (original[property]) card.style.setProperty(property, original[property], original[`${property}Priority`]);
          else card.style.removeProperty(property);
        }
        card.toggleAttribute('inert', original.inert);
        if (original.snippetLines) card.style.setProperty('--review-snippet-lines', original.snippetLines, original.snippetLinesPriority);
        else card.style.removeProperty('--review-snippet-lines');
      });
      if (this._selectedEditorCard) this._restoreEditorExpanded();
      this._selectedEditorCard = null;
      this._scrollToCard = null;
    }
  }

  customElements.define(tagName, AgencyReviewHighlights);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blend-newsletter-popup"]) return;
  try {
    
if (!customElements.get('blend-newsletter-popup')) {
  class BlendNewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      clearTimeout(this.mobileTimer);
      this.cardsObserver?.disconnect();
      this.positionObserver?.disconnect();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.dialog = this.querySelector('[data-popup-dialog]');
      this.form = this.querySelector('[data-popup-form]');
      this.status = this.querySelector('[data-popup-status]');
      this.closeButton = this.querySelector('[data-popup-close]');
      this.cards = this.querySelector('.blend-newsletter-popup__cards');
      this.reviewPrev = this.querySelector('[data-review-prev]');
      this.reviewNext = this.querySelector('[data-review-next]');
      this.reviewStatus = this.querySelector('[data-review-status]');
      this.reviewPrev?.addEventListener('click', () => this.moveReview(-1), { signal });
      this.reviewNext?.addEventListener('click', () => this.moveReview(1), { signal });
      this.cards?.addEventListener('scroll', () => this.updateReviewNavigation(), { signal, passive: true });
      // The legacy "seen" flag recorded a display, not a subscription.
      this.storageKey = 'blend:newsletter:popup:v2';
      this.sessionKey = `${this.storageKey}:shown`;
      this.dismissedKey = `${this.storageKey}:dismissed-until`;
      this.subscribedKey = 'blend:newsletter:subscribed';
      this.pointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.mobileQuery = window.matchMedia('(max-width: 767px), (hover: none), (pointer: coarse)');
      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.entered = false;
      this.exitGeneration = (this.exitGeneration || 0) + 1;
      this.contactOpen = false;
      this.preview = Boolean(window.Shopify?.designMode && this.dataset.preview === 'true');
      if (!this.dialog || !this.form) return;
      this.mobileElapsed = 0;
      try { this.mobileElapsed = Math.min(30000, Number(sessionStorage.getItem(`${this.storageKey}:active-ms`)) || 0); } catch {}
      this.mobileLastTick = null;
      this.pageActive = true;
      this.mobileQuery.addEventListener?.('change', () => this.scheduleMobile(), { signal });
      window.addEventListener('message', (event) => this.onFormMessage(event), { signal });

      if (this.cards && typeof ResizeObserver !== 'undefined') {
        let previousWidth = 0;
        this.cardsObserver = new ResizeObserver(([entry]) => {
          const width = entry.contentRect.width;
          if (width > 0 && width !== previousWidth) {
            previousWidth = width;
            this.sizeReviewCards();
            this.updateReviewNavigation();
          }
        });
        this.cardsObserver.observe(this.cards);
        document.fonts?.ready.then(() => { if (this.isConnected) this.sizeReviewCards(); });
      }

      if (typeof ResizeObserver !== 'undefined') {
        this.positionObserver = new ResizeObserver(() => this.clampPosition());
        this.positionObserver.observe(this.dialog);
      }
      this.dialog.addEventListener('pointerenter', (event) => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom) this.freezeMotion();
      }, { signal });
      this.dialog.addEventListener('pointerdown', () => this.freezeMotion(), { signal });
      this.dialog.addEventListener('focusin', () => this.freezeMotion(), { signal });
      this.dialog.addEventListener('keydown', () => this.freezeMotion(), { signal });
      window.addEventListener('blur', () => {
        if (!this.pointerOutside) this.freezeMotion();
        this.pointerOutside = true;
        this.lastPointer = null;
      }, { signal });
      this.reducedMotionQuery.addEventListener?.('change', () => this.freezeMotion(), { signal });

      this.closeButton?.addEventListener('click', () => this.close('dismiss'), { signal });
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close('escape');
      }, { signal });
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.close('backdrop');
      }, { signal });
      this.dialog.addEventListener('close', () => this.restoreScroll(), { signal });

      document.addEventListener('blend:contact-drawer-state', (event) => {
        this.contactOpen = event.detail?.open === true;
        this.entered = false;
        this.exitGeneration += 1;
        if (this.contactOpen) this.close('contact');
      }, { signal });
      document.addEventListener('pointermove', (event) => {
        if (!event.isTrusted || event.pointerType !== 'mouse' || event.clientY < 0) return;
        this.exitGeneration += 1;
        if (this.dialog.open) { this.onPointerReturn(event); return; }
        if (event.clientY > 40 && !this.isBlocked()) {
          this.entered = true;
          if (this.eligible()) this.mountForm();
        }
      }, { signal, passive: true });
      document.addEventListener('pointerover', (event) => {
        if (event.isTrusted && event.pointerType === 'mouse' && event.relatedTarget === null && this.dialog.open) this.onPointerReturn(event);
      }, { signal, passive: true });
      document.addEventListener('mouseout', (event) => this.onExit(event), { signal, passive: true });
      document.addEventListener('visibilitychange', () => {
        this.entered = false;
        this.exitGeneration += 1;
        this.freezeMotion();
        this.pointerOutside = true;
        this.lastPointer = null;
        this.scheduleMobile();
      }, { signal });
      window.addEventListener('storage', (event) => {
        if ([this.dismissedKey, this.subscribedKey].includes(event.key) && event.newValue) {
          this.entered = false;
          this.scheduleMobile();
        }
      }, { signal });
      window.addEventListener('pagehide', () => {
        this.exitGeneration += 1;
        this.pageActive = false;
        this.scheduleMobile();
        this.close('navigation');
      }, { signal });
      window.addEventListener('pageshow', () => { this.pageActive = true; this.scheduleMobile(); }, { signal });
      window.addEventListener('resize', () => { this.freezeMotion(); this.clampPosition(); }, { signal, passive: true });
      document.addEventListener('shopify:section:select', (event) => {
        if (this.preview && event.detail?.sectionId === this.dataset.sectionId) this.open(true);
      }, { signal });

      if (this.preview) this.open(true);
      else if (this.dataset.enabled === 'true') {
        this.loadAttribution();
        this.scheduleMobile();
      }
    }

    disconnectedCallback() {
      clearTimeout(this.mobileTimer);
      this.mobileLastTick = null;
      this.exitGeneration += 1;
      this.close('disconnect');
      this.controller?.abort();
      this.positionObserver?.disconnect();
      this.formObserver?.disconnect();
      this.cardsObserver?.disconnect();
    }

    reviewIndex() {
      if (!this.cards?.children.length) return 0;
      const start = this.cards.getBoundingClientRect().left;
      return Array.from(this.cards.children).reduce((nearest, card, index, cards) =>
        Math.abs(card.getBoundingClientRect().left - start) < Math.abs(cards[nearest].getBoundingClientRect().left - start) ? index : nearest, 0);
    }

    updateReviewNavigation() {
      if (!this.cards || !this.reviewStatus) return;
      const index = this.reviewIndex();
      this.reviewPrev.disabled = index === 0;
      this.reviewNext.disabled = index === this.cards.children.length - 1;
      this.reviewStatus.textContent = `${index + 1} / ${this.cards.children.length}`;
    }

    moveReview(direction) {
      if (!this.cards) return;
      const index = Math.max(0, Math.min(this.reviewIndex() + direction, this.cards.children.length - 1));
      const card = this.cards.children[index];
      const left = this.cards.scrollLeft + card.getBoundingClientRect().left - this.cards.getBoundingClientRect().left;
      this.cards.scrollTo({ left, behavior: this.reducedMotionQuery.matches ? 'instant' : 'smooth' });
    }

    sizeReviewCards() {
      if (!this.dialog?.open || !this.cards) return;
      // Measure closed copies so expanding a review never stretches its neighbour.
      const heights = Array.from(this.cards.children).filter((card) => !card.classList.contains('blend-newsletter-popup__card--board')).map((card) => {
        const copy = card.cloneNode(true);
        copy.querySelectorAll('details').forEach((details) => { details.open = false; });
        copy.inert = true;
        copy.setAttribute('aria-hidden', 'true');
        Object.assign(copy.style, { position: 'absolute', left: '-10000px', top: '0', visibility: 'hidden', width: `${card.getBoundingClientRect().width}px`, height: 'auto', minHeight: '0', pointerEvents: 'none' });
        this.dialog.append(copy);
        const height = copy.getBoundingClientRect().height;
        copy.remove();
        return height;
      });
      if (heights.length) this.cards.style.setProperty('--popup-card-height', `${Math.ceil(Math.max(...heights))}px`);
    }

    hasSeen() {
      if (this.shownThisVisit || this.subscribed) return true;
      // Beehiiv also remembers subscribers who joined through the footer or an earlier form.
      try {
        const prefix = `bhv_${this.dataset.publicationId}_subscribed=`;
        if (this.dataset.publicationId && document.cookie.split(';').some((cookie) => cookie.trim().startsWith(prefix) && cookie.trim().length > prefix.length)) return true;
      } catch {}
      try {
        if (sessionStorage.getItem(this.sessionKey)) return true;
      } catch {}
      try {
        return Boolean(localStorage.getItem(this.subscribedKey)) || Number(localStorage.getItem(this.dismissedKey)) > Date.now();
      } catch { return false; }
    }

    scheduleMobile() {
      clearTimeout(this.mobileTimer);
      this.mobileLastTick = null;
      if (this.preview || window.Shopify?.designMode || this.dataset.enabled !== 'true' ||
          !this.pageActive || !this.isConnected || !this.mobileQuery.matches ||
          document.visibilityState !== 'visible' || this.hasSeen() || this.dataset.shopifyCustomerSubscribed === 'true') return;
      this.mobileLastTick = performance.now();
      this.mobileTimer = setTimeout(() => this.tickMobile(), 1000);
    }

    tickMobile() {
      if (this.mobileLastTick === null) return;
      if (document.visibilityState !== 'visible' || !this.pageActive || !this.mobileQuery.matches) {
        this.scheduleMobile();
        return;
      }
      const elapsed = Math.max(0, Math.min(1500, performance.now() - this.mobileLastTick));
      // Do not interrupt contact forms, keyboards, or other open dialogs.
      if (!this.isBlocked() && !this.isEditing()) {
        this.mobileElapsed = Math.min(30000, this.mobileElapsed + elapsed);
        try { sessionStorage.setItem(`${this.storageKey}:active-ms`, String(this.mobileElapsed)); } catch {}
        if (this.mobileElapsed >= 25000 && this.eligible()) this.mountForm();
        if (this.mobileElapsed >= 30000 && this.eligible()) this.requestOpen();
      }
      this.scheduleMobile();
    }

    isEditing() {
      return Boolean(document.activeElement?.matches('input, textarea, select, iframe, [contenteditable="true"]'));
    }

    requestOpen(exitX = null) {
      const generation = this.exitGeneration;
      const open = () => {
        if (generation === this.exitGeneration && !this.isEditing()) this.open(false, exitX);
      };
      if (navigator.locks?.request) {
        navigator.locks.request(this.storageKey, { ifAvailable: true }, (lock) => { if (lock) open(); }).catch(() => {});
      } else open();
    }

    onFormMessage(event) {
      const frame = this.form.querySelector('iframe');
      if (this.preview || !frame || event.source !== frame.contentWindow ||
          event.origin !== 'https://subscribe-forms.beehiiv.com' || !event.data || typeof event.data !== 'object') return;
      if (event.data.type === 'beehiiv:styles') {
        const height = Number.parseFloat(event.data.payload?.height);
        const width = Number.parseFloat(event.data.payload?.width);
        if (Number.isFinite(height) && height > 0 && Number.isFinite(width) && width > 0) {
          this.formReady = true;
          this.trackReady();
        }
        return;
      }
      if (this.subscribed || !['beehiiv:success-toast', 'beehiiv:submitted'].includes(event.data.type)) return;
      this.subscribed = true;
      try { localStorage.setItem(this.subscribedKey, '1'); } catch {}
      clearTimeout(this.mobileTimer);
      this.close('subscribed');
      if (this.status) this.status.textContent = 'Thanks! Check your inbox for the next step.';
      this.track('newsletter_popup_signup');
    }

    isBlocked() {
      return this.contactOpen || Boolean(document.querySelector('agency-contact-drawer dialog[open]')) ||
        Array.from(document.querySelectorAll('dialog[open]')).some((dialog) => dialog !== this.dialog);
    }

    eligible() {
      return this.dataset.enabled === 'true' && !window.Shopify?.designMode &&
        this.dataset.shopifyCustomerSubscribed !== 'true' &&
        document.visibilityState === 'visible' && this.isConnected && !this.dialog.open &&
        !this.isBlocked() && !this.hasSeen() && Boolean(this.form.dataset.src);
    }

    onExit(event) {
      if (this.dialog.open) {
        if (!event.isTrusted || event.relatedTarget !== null) return;
        const { clientX: x, clientY: y } = event;
        if (!Number.isFinite(x) || !Number.isFinite(y)) return;
        const bounds = this.positionBounds();
        let left = Math.max(bounds.x, Math.min(x - bounds.rect.width / 2, bounds.maxX));
        let top = Math.max(bounds.y, Math.min(y - bounds.rect.height / 2, bounds.maxY));
        if (y <= 0) top = bounds.y;
        else if (y >= window.innerHeight) top = bounds.maxY;
        else if (x <= 0) left = bounds.x;
        else if (x >= window.innerWidth) left = bounds.maxX;
        else return;
        this.freezeMotion();
        this.pointerOutside = true;
        this.lastPointer = null;
        this.setPosition(left, top, true, 5);
        return;
      }
      if (!event.isTrusted || event.relatedTarget !== null || event.clientY > 0 || event.clientX < 0 || event.clientX > window.innerWidth) return;
      if (!this.pointerQuery.matches || this.mobileQuery.matches) return;
      if (!this.entered || !this.eligible()) return;
      this.entered = false;
      this.requestOpen(event.clientX);
    }

    open(preview = false, exitX = null) {
      if (this.isBlocked() || this.dialog.open) return false;
      if (preview) {
        if (!this.preview || !window.Shopify?.designMode) return false;
      } else {
        if (!this.eligible()) return false;
      }
      this.previousFocus = document.activeElement;
      this.previousOverflow = document.documentElement.style.overflow;
      this.exitX = Number.isFinite(exitX) ? exitX : null;
      this.followPoint = null;
      this.lastPointer = null;
      this.pointerOutside = this.exitX !== null;
      Object.assign(this.dialog.style, { margin: '', left: '', right: '', top: '', bottom: '', transition: '', transform: '', willChange: '' });
      this.dialog.showModal();
      if (!preview) {
        this.popupInstanceId = window.crypto?.randomUUID?.() || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
        this.popupTrigger = this.mobileQuery.matches ? 'mobile_30s' : 'desktop_exit';
        this.popupDevice = this.mobileQuery.matches ? 'mobile' : 'desktop';
        this.popupEvents = new Set();
        this.measurementCohort = this.canMeasure();
        this.measurementQa = this.measurementCohort && new URL(window.location.href).searchParams.get('newsletter_popup_test') === '1';
        this.measurementViewSent = false;
        this.shownThisVisit = true;
        try { sessionStorage.setItem(this.sessionKey, '1'); } catch {}
        clearTimeout(this.mobileTimer);
      }
      document.documentElement.style.overflow = 'hidden';
      this.sizeReviewCards();
      if (this.cards) this.cards.scrollLeft = 0;
      this.updateReviewNavigation();
      this.dialog.focus({ preventScroll: true });
      this.mountForm();
      if (this.exitX !== null) {
        const centre = this.dialog.getBoundingClientRect();
        this.setPosition(centre.left, centre.top, false);
        this.openFrame = requestAnimationFrame(() => {
          this.openFrame = requestAnimationFrame(() => {
            this.openFrame = null;
            this.positionNearExit();
          });
        });
      }
      if (!preview) {
        this.track('newsletter_popup_view');
        this.trackReady();
      }
      return true;
    }

    positionBounds() {
      const rect = this.dialog.getBoundingClientRect();
      const x = Math.max(0, Math.min(16, (window.innerWidth - rect.width) / 2));
      const y = Math.max(0, Math.min(16, (window.innerHeight - rect.height) / 2));
      return { rect, x, y, maxX: Math.max(x, window.innerWidth - rect.width - x), maxY: Math.max(y, window.innerHeight - rect.height - y) };
    }

    setPosition(left, top, animate = true, speed = 8) {
      this.dataset.following = animate && !this.reducedMotionQuery.matches && this.followPoint ? 'true' : 'false';
      const bounds = this.positionBounds();
      const targetX = Math.max(bounds.x, Math.min(left, bounds.maxX));
      const targetY = Math.max(bounds.y, Math.min(top, bounds.maxY));
      if (!animate || this.reducedMotionQuery.matches) {
        cancelAnimationFrame(this.motionFrame);
        this.motionFrame = null;
        this.motion = null;
        Object.assign(this.dialog.style, { transition: 'none', transform: '', willChange: '', margin: '0', right: 'auto', bottom: 'auto', left: `${targetX}px`, top: `${targetY}px` });
        return;
      }
      if (!this.motion) {
        const { left: x, top: y } = bounds.rect;
        this.motion = { x, y, baseX: x, baseY: y, vx: 0, vy: 0, time: null };
        Object.assign(this.dialog.style, { transition: 'none', transform: '', willChange: 'transform', margin: '0', right: 'auto', bottom: 'auto', left: `${x}px`, top: `${y}px` });
      }
      if (this.followPoint) {
        if (this.motion.vx * (targetX - this.motion.x) <= 0) this.motion.vx = 0;
        if (this.motion.vy * (targetY - this.motion.y) <= 0) this.motion.vy = 0;
      }
      Object.assign(this.motion, { targetX, targetY, speed });
      if (!this.motionFrame) this.motionFrame = requestAnimationFrame((time) => this.animatePosition(time));
    }

    animatePosition(time) {
      this.motionFrame = null;
      const motion = this.motion;
      if (!motion || !this.dialog.open) return;
      const dt = motion.time === null ? 0 : Math.min((time - motion.time) / 1000, .064);
      motion.time = time;
      const decay = Math.exp(-motion.speed * dt);
      for (const [axis, velocity, target] of [['x', 'vx', 'targetX'], ['y', 'vy', 'targetY']]) {
        const distance = motion[axis] - motion[target];
        const momentum = motion[velocity] + motion.speed * distance;
        motion[axis] = motion[target] + (distance + momentum * dt) * decay;
        motion[velocity] = (motion[velocity] - motion.speed * momentum * dt) * decay;
      }
      const bounds = this.positionBounds();
      const point = this.followPoint;
      let x = Math.max(bounds.x, Math.min(motion.x, bounds.maxX));
      let y = Math.max(bounds.y, Math.min(motion.y, bounds.maxY));
      if (point && this.pointerDistance(point, { left: x, top: y, right: x + bounds.rect.width, bottom: y + bounds.rect.height }) > this.pointerDistance(point, bounds.rect) + .01) {
        this.freezeMotion();
        return;
      }
      let reachedBuffer = false;
      if (point && !this.withinPointerBuffer(point, bounds.rect.left, bounds.rect.top, bounds.rect) &&
          this.withinPointerBuffer(point, x, y, bounds.rect)) {
        let start = 0;
        let end = 1;
        for (let iteration = 0; iteration < 16; iteration += 1) {
          const fraction = (start + end) / 2;
          const nextX = bounds.rect.left + (x - bounds.rect.left) * fraction;
          const nextY = bounds.rect.top + (y - bounds.rect.top) * fraction;
          if (this.withinPointerBuffer(point, nextX, nextY, bounds.rect)) end = fraction;
          else start = fraction;
        }
        x = bounds.rect.left + (x - bounds.rect.left) * start;
        y = bounds.rect.top + (y - bounds.rect.top) * start;
        reachedBuffer = true;
      }
      if (x !== motion.x) motion.vx = 0;
      if (y !== motion.y) motion.vy = 0;
      motion.x = x;
      motion.y = y;
      this.dialog.style.transform = `translate3d(${x - motion.baseX}px, ${y - motion.baseY}px, 0)`;
      if (reachedBuffer) {
        this.freezeMotion();
        return;
      }
      if (Math.abs(x - motion.targetX) < .1 && Math.abs(y - motion.targetY) < .1 && Math.abs(motion.vx) < .5 && Math.abs(motion.vy) < .5) {
        this.setPosition(motion.targetX, motion.targetY, false);
      } else {
        this.motionFrame = requestAnimationFrame((nextTime) => this.animatePosition(nextTime));
      }
    }

    positionNearExit() {
      if (!this.dialog?.open || this.exitX === null) return;
      const { rect, y } = this.positionBounds();
      this.setPosition(this.exitX - rect.width / 2, y, true, 5);
    }

    freezeMotion() {
      this.dataset.following = 'false';
      cancelAnimationFrame(this.openFrame);
      this.openFrame = null;
      cancelAnimationFrame(this.motionFrame);
      this.motionFrame = null;
      this.followPoint = null;
      if (!this.dialog?.open || this.exitX === null || this.exitX === undefined) return;
      const rect = this.dialog.getBoundingClientRect();
      this.setPosition(rect.left, rect.top, false);
    }

    clampPosition() {
      if (!this.dialog?.open || this.exitX === null || this.exitX === undefined) return;
      const { rect, x, y, maxX, maxY } = this.positionBounds();
      if (rect.left < x || rect.left > maxX || rect.top < y || rect.top > maxY ||
          (this.motion && (this.motion.targetX < x || this.motion.targetX > maxX || this.motion.targetY < y || this.motion.targetY > maxY))) {
        this.freezeMotion();
      }
    }

    onPointerReturn(event) {
      if (!event.isTrusted || event.pointerType !== 'mouse' || event.clientX < 0 || event.clientX > window.innerWidth || event.clientY < 0 || event.clientY > window.innerHeight) return;
      if (this.pointerOutside) {
        this.freezeMotion();
        this.pointerOutside = false;
        this.lastPointer = null;
      }
      this.followPointer(event);
    }

    pointerDistance(point, rect) {
      return Math.hypot(Math.max(rect.left - point.x, 0, point.x - rect.right), Math.max(rect.top - point.y, 0, point.y - rect.bottom));
    }

    withinPointerBuffer(point, left, top, size) {
      return Math.abs(point.x - left - size.width / 2) <= size.width / 2 + 32 &&
        Math.abs(point.y - top - size.height / 2) <= size.height / 2 + 32;
    }

    followPointer(event) {
      if (!event.isTrusted || event.pointerType !== 'mouse' || !this.dialog.open || this.exitX === null) return;
      if (!this.pointerQuery.matches || this.reducedMotionQuery.matches || event.buttons ||
          document.activeElement?.matches('input, textarea, select, iframe, [contenteditable="true"]')) {
        this.freezeMotion();
        return;
      }
      const rect = this.dialog.getBoundingClientRect();
      const x = event.clientX;
      const y = event.clientY;
      if (!Number.isFinite(x) || !Number.isFinite(y)) return;
      const point = { x, y };
      const distance = this.pointerDistance(point, rect);
      const previousDistance = this.lastPointer ? this.pointerDistance(this.lastPointer, rect) : distance;
      this.lastPointer = point;
      if (distance < previousDistance - 1) {
        this.freezeMotion();
        return;
      }
      if (this.openFrame) return;
      if (this.withinPointerBuffer(point, rect.left, rect.top, rect)) {
        this.freezeMotion();
        return;
      }
      const halfWidth = rect.width / 2;
      const halfHeight = rect.height / 2;
      const dx = x - (rect.left + halfWidth);
      const dy = y - (rect.top + halfHeight);
      const left = rect.left + dx - Math.max(-halfWidth - 32, Math.min(dx, halfWidth + 32));
      const top = rect.top + dy - Math.max(-halfHeight - 32, Math.min(dy, halfHeight + 32));
      this.followPoint = { x, y };
      this.setPosition(left, top);
    }

    close(reason) {
      this.freezeMotion();
      if (!this.dialog?.open) return;
      if (!this.preview && ['dismiss', 'escape', 'backdrop'].includes(reason)) {
        try { localStorage.setItem(this.dismissedKey, String(Date.now() + 7 * 24 * 60 * 60 * 1000)); } catch {}
      }
      this.dialog.close();
      this.restoreScroll();
      if (!this.preview && ['dismiss', 'escape', 'backdrop'].includes(reason)) this.track('newsletter_popup_dismiss', { dismissal_reason: reason });
      if (reason !== 'contact' && reason !== 'disconnect' && reason !== 'navigation' && this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
    }

    restoreScroll() {
      if (this.previousOverflow === undefined) return;
      if (document.documentElement.style.overflow === 'hidden') document.documentElement.style.overflow = this.previousOverflow;
      this.previousOverflow = undefined;
    }

    canMeasure() {
      try {
        const url = new URL(window.location.href);
        return !this.preview && !window.Shopify?.designMode && !window.Shopify?.inspectMode &&
          window.Shopify?.theme?.role === 'main' &&
          ['blendcommerce.com', 'www.blendcommerce.com'].includes(url.hostname.toLowerCase()) &&
          !['preview_theme_id', '_fd', '_sc'].some((key) => url.searchParams.has(key)) &&
          window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true &&
          document.documentElement.dataset.blendAnalytics === 'allowed' &&
          window['ga-disable-G-C71KQBEKW5'] !== true && typeof window.gtag === 'function';
      } catch { return false; }
    }

    trackReady() {
      if (this.formReady && this.dialog?.open) this.track('newsletter_popup_ready');
    }

    track(event, extra = {}) {
      if (this.preview || window.Shopify?.designMode) return;
      this.popupEvents ||= new Set();
      if (this.popupEvents.has(event)) return;
      this.popupEvents.add(event);
      const formId = this.form.dataset.src.match(/\/([a-f0-9-]{36})(?:\?|\/?$)/i)?.[1] || '';
      const eventName = this.measurementQa ? `${event}_qa` : event;
      const parameters = {
        form_name: 'Website newsletter popup - desktop exit and mobile 30s - 2026-10-12',
        form_id: formId,
        form_location: 'newsletter_popup',
        popup_version: '2026-10-12-measurement-1',
        trigger_type: this.popupTrigger || (this.mobileQuery.matches ? 'mobile_30s' : 'desktop_exit'),
        popup_device: this.popupDevice || (this.mobileQuery.matches ? 'mobile' : 'desktop'),
        event_id: `${this.popupInstanceId || 'unshown'}:${eventName}`
      };
      if (this.measurementQa) parameters.debug_mode = true;
      if (event === 'newsletter_popup_dismiss' && ['dismiss', 'escape', 'backdrop'].includes(extra.dismissal_reason)) {
        parameters.dismissal_reason = extra.dismissal_reason;
      }
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, ...parameters, measurement_collector: 'direct_gtag' });
        if (!this.measurementCohort || !this.canMeasure() ||
            (event !== 'newsletter_popup_view' && !this.measurementViewSent)) return;
        window.gtag('event', eventName, { send_to: 'G-C71KQBEKW5', ...parameters });
        if (event === 'newsletter_popup_view') this.measurementViewSent = true;
      } catch {}
    }

    loadAttribution() {
      if (document.querySelector('script[src="https://subscribe-forms.beehiiv.com/attribution.js"]')) return;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://subscribe-forms.beehiiv.com/attribution.js';
      document.head.append(script);
    }

    mountForm() {
      if (this.form.dataset.loaded === 'true') return;
      let url;
      try { url = new URL(this.form.dataset.src); } catch { return; }
      const id = url.pathname.match(/\/([a-f0-9-]{36})\/?$/i)?.[1];
      if (url.origin !== 'https://subscribe-forms.beehiiv.com' || !id) return;
      this.form.dataset.loaded = 'true';
      this.loadAttribution();
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://subscribe-forms.beehiiv.com/v3/loader.js';
      script.dataset.beehiivForm = id;
      script.addEventListener('error', () => {
        const message = document.createElement('p');
        message.textContent = 'The signup form couldn’t load. ';
        const link = document.createElement('a');
        link.href = url.href;
        link.target = '_blank';
        link.rel = 'noopener';
        link.textContent = 'Open the signup form';
        message.append(link);
        this.form.replaceChildren(message);
      }, { once: true });
      this.formObserver = new MutationObserver(() => {
        const frame = this.form.querySelector('iframe');
        if (frame) {
          frame.title = 'Subscribe to the Blend Commerce newsletter';
          frame.loading = 'eager';
          this.formObserver.disconnect();
        }
      });
      this.formObserver.observe(this.form, { childList: true, subtree: true });
      this.form.replaceChildren(script);
    }
  }
  customElements.define('blend-newsletter-popup', BlendNewsletterPopup);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collapsible-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blend-faq')) {
    customElements.define('blend-faq', class extends HTMLElement {
      connectedCallback() {
        this.rows = [...this.querySelectorAll('.blend-faq__details')];
        this.animations = new Map();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.rows.forEach((row) => {
          this.syncRow(row, row.open);
          row.addEventListener('toggle', () => {
            if (this.animations.has(row)) return;
            this.syncRow(row, row.open);
            if (row.open) this.closeOtherRows(row);
          }, options);
        });

        this.addEventListener('click', (event) => {
          const summary = event.target.closest('.blend-faq__summary');
          if (!summary || !this.contains(summary)) return;
          event.preventDefault();
          const row = summary.parentElement;
          const opening = row.dataset.open !== 'true';
          if (opening) this.closeOtherRows(row);
          this.setOpen(row, opening);
        }, options);

        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const row = event.target.closest('.blend-faq__details');
          if (!row || row.dataset.open !== 'true') return;
          event.preventDefault();
          this.setOpen(row, false);
          row.querySelector('summary').focus();
        }, options);

        this.addEventListener('shopify:block:select', (event) => {
          const row = event.target.querySelector('.blend-faq__details');
          if (!row) return;
          this.closeOtherRows(row);
          this.setOpen(row, true);
        }, options);
      }

      disconnectedCallback() {
        this.controller.abort();
        this.animations.forEach((animation) => animation.cancel());
      }

      syncRow(row, open) {
        row.dataset.open = String(open);
        row.querySelector('summary').setAttribute('aria-expanded', String(open));
        row.querySelector('.blend-faq__answer').inert = !open;
      }

      closeOtherRows(activeRow) {
        this.rows.forEach((row) => {
          if (row !== activeRow && row.dataset.open === 'true') this.setOpen(row, false);
        });
      }

      setOpen(row, open) {
        const startHeight = row.getBoundingClientRect().height;
        this.animations.get(row)?.cancel();
        this.animations.delete(row);
        this.syncRow(row, open);

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !row.animate) {
          row.open = open;
          row.style.overflow = '';
          return;
        }

        row.open = true;
        const endHeight = open ? row.getBoundingClientRect().height : row.querySelector('summary').getBoundingClientRect().height;
        row.style.overflow = 'hidden';
        const animation = row.animate(
          { height: [`${startHeight}px`, `${endHeight}px`] },
          { duration: 320, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        );
        this.animations.set(row, animation);
        animation.onfinish = () => {
          if (this.animations.get(row) !== animation) return;
          this.animations.delete(row);
          row.open = open;
          row.style.overflow = '';
          animation.cancel();
        };
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-aov-calculator"] && !Shopify.designMode) return;
  try {
    
    (function(){
        emailjs.init("2i48htRz-HRDWM8kH"); // Your Public Key
    })();
    document.addEventListener('DOMContentLoaded', function () {
        // Define question weights per type
        const questionWeights = {
            'q1': { 'CR': 1.0, 'AOV': 0.5 },
            'q2': { 'CR': 1.0, 'AOV': 0.5 },
            'q3': { 'CR': 1.0, 'AOV': 0.5 },
            'q4': { 'CR': 0.9, 'AOV': 0.4 },
            'q5': { 'CR': 0.9, 'AOV': 0.4 },
            'q6': { 'CR': 0.9, 'AOV': 0.4 },
            'q7': { 'CR': 0.5, 'AOV': 1.0 },
            'q8': { 'CR': 0.5, 'AOV': 1.0 },
            'q9': { 'CR': 0.5, 'AOV': 1.0 },
            'q10': { 'CR': 1.0, 'AOV': 0.5 },
            'q11': { 'CR': 1.0, 'AOV': 0.5 },
            'q12': { 'CR': 1.0, 'AOV': 0.5 },
            'q13': { 'CR': 1.0, 'AOV': 0.6 },
            'q14': { 'CR': 1.0, 'AOV': 0.6 },
            'q15': { 'CR': 1.0, 'AOV': 0.6 },
            'q16': { 'CR': 0.6, 'AOV': 1.0 },
            'q17': { 'CR': 0.6, 'AOV': 1.0 },
            'q18': { 'CR': 0.8, 'AOV': 0.4 },
            'q19': { 'CR': 0.8, 'AOV': 0.4 },
            'q20': { 'CR': 0.5, 'AOV': 1.0 }
        };

        // Define section weights per type
        const sectionWeights = {
            'Product Discovery and Navigation': { 'CR': 1.0, 'AOV': 0.5 },
            'Social Proof and UGC': { 'CR': 0.9, 'AOV': 0.4 },
            'User Experience and Site Performance': { 'CR': 1.0, 'AOV': 0.5 },
            'Checkout Experience': { 'CR': 1.0, 'AOV': 0.6 },
            'Trust and Credibility': { 'CR': 0.8, 'AOV': 0.4 },
            'Upselling and Cross-selling Strategies': { 'CR': 0.5, 'AOV': 1.0 },
            'Personalization and Engagement': { 'CR': 0.6, 'AOV': 1.0 },
            'Promotional Strategies': { 'CR': 0.5, 'AOV': 1.0 }
        };

        // Handle form submission
        document.getElementById('potentialForm').addEventListener('submit', function (e) {
            e.preventDefault();

            // Collect input values
            const clientName = document.getElementById('clientName').value;
            const clientBusiness = document.getElementById('clientBusiness').value;
            const email = document.getElementById('email').value;
            const consent = document.getElementById('consent').checked;

            if (!validateEmail(email) || !consent) {
                alert("Please provide valid inputs and agree to the consent.");
                return;
            }

            // Collect Likert scale responses
            const responses = {};
            for (let i = 1; i <= 20; i++) {
                const qValue = document.querySelector(`input[name="q${i}"]:checked`);
                if (qValue) {
                    responses[`q${i}`] = parseInt(qValue.value);
                } else {
                    alert(`Please answer question ${i}.`);
                    return;
                }
            }

            // Define question groups for scoring
            const sections = [
                { name: 'Product Discovery and Navigation', questions: ['q1', 'q2', 'q3'] },
                { name: 'Social Proof and UGC', questions: ['q4', 'q5', 'q6'] },
                { name: 'Upselling and Cross-selling Strategies', questions: ['q7', 'q8', 'q9'] },
                { name: 'User Experience and Site Performance', questions: ['q10', 'q11', 'q12'] },
                { name: 'Checkout Experience', questions: ['q13', 'q14', 'q15'] },
                { name: 'Personalization and Engagement', questions: ['q16', 'q17'] },
                { name: 'Trust and Credibility', questions: ['q18', 'q19'] },
                { name: 'Promotional Strategies', questions: ['q20'] }
            ];

            // Helper function to merge results
            function mergeResults(crResults, aovResults) {
                const resultMap = new Map();
            
                crResults.forEach(result => {
                    resultMap.set(result.sectionName, {
                        sectionName: result.sectionName,
                        totalScore: result.averageScore,
                        count: 1
                    });
                });
            
                aovResults.forEach(result => {
                    if (resultMap.has(result.sectionName)) {
                        const existing = resultMap.get(result.sectionName);
                        existing.totalScore += result.averageScore;
                        existing.count += 1;
                    } else {
                        resultMap.set(result.sectionName, {
                            sectionName: result.sectionName,
                            totalScore: result.averageScore,
                            count: 1
                        });
                    }
                });
            
                const mergedResults = [];
                resultMap.forEach(value => {
                    mergedResults.push({
                        sectionName: value.sectionName,
                        averageScore: value.totalScore / value.count
                    });
                });
            
                return mergedResults;
            }

            // Calculate average scores and potential improvements
            const crResults = calculateSectionScores(responses, sections, 'CR');
            const aovResults = calculateSectionScores(responses, sections, 'AOV');
        
            // Calculate overall potential improvements
            const crOverallImprovement = calculateOverallImprovement(crResults, 'CR');
            const aovOverallImprovement = calculateOverallImprovement(aovResults, 'AOV');
        
            // Merge results to avoid duplication
            const mergedResults = mergeResults(crResults, aovResults);
        
            // Generate the report
            const reportString = generateReport(clientName, clientBusiness, crOverallImprovement, aovOverallImprovement, crResults, aovResults, mergedResults);
        
            // Send report via EmailJS
            emailjs.send('service_f1yxxyh', 'template_beqzvab', {
                name: clientName,
                email: email,
                business: clientBusiness,
                date: new Date().toLocaleDateString(),
                cr_potential: crOverallImprovement.toFixed(1) + '%',
                aov_potential: aovOverallImprovement.toFixed(1) + '%',
                strengths_section: generateStrengths(mergedResults),
                weaknesses_section: generateWeaknesses(mergedResults),
                cr_recommendations: generateEmailRecommendations(crResults, 'CR'),
                aov_recommendations: generateEmailRecommendations(aovResults, 'AOV')
            })
            .then(function (response) {
                console.log('SUCCESS!', response.status, response.text);
            }, function (error) {
                console.log('FAILED...', error);
            });
        
            // Display the report
            document.getElementById('potentialReport').innerHTML = reportString;
            document.getElementById('result').style.display = 'block';
            document.getElementById('reportCover').style.display = 'none';
        });

        // Helper functions
        function validateEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(String(email).toLowerCase());
        }

        function calculateSectionScores(responses, sections, type) {
            const results = [];
            sections.forEach(section => {
                let total = 0;
                let weightSum = 0;
                section.questions.forEach(q => {
                    const weight = questionWeights[q][type];
                    total += responses[q] * weight;
                    weightSum += weight;
                });
                const averageScore = total / weightSum;
                const potentialImprovement = calculateImprovement(averageScore, type);
                const priorityScore = potentialImprovement * sectionWeights[section.name][type];
                results.push({
                    sectionName: section.name,
                    averageScore,
                    potentialImprovement,
                    priorityScore,
                    questions: section.questions
                });
            });
            return results;
        }

        function calculateImprovement(score, type) {
            let potentialImprovement = 0;
            if (type === 'CR') {
                if (score >= 1 && score <= 1.5) {
                    potentialImprovement = 37.5;
                } else if (score > 1.5 && score <= 2.5) {
                    potentialImprovement = 32.5;
                } else if (score > 2.5 && score <= 3.5) {
                    potentialImprovement = 22.5;
                } else if (score > 3.5 && score <= 4.5) {
                    potentialImprovement = 10;
                } else if (score > 4.5 && score <= 5) {
                    potentialImprovement = 0;
                }
            } else if (type === 'AOV') {
                if (score >= 1 && score <= 1.5) {
                    potentialImprovement = 23.75;
                } else if (score > 1.5 && score <= 2.5) {
                    potentialImprovement = 21.25;
                } else if (score > 2.5 && score <= 3.5) {
                    potentialImprovement = 15;
                } else if (score > 3.5 && score <= 4.5) {
                    potentialImprovement = 7.5;
                } else if (score > 4.5 && score <= 5) {
                    potentialImprovement = 0;
                }
            }
            return potentialImprovement;
        }

        function calculateOverallImprovement(results, type) {
            let totalPotential = 0;
            let totalWeight = 0;
            results.forEach(result => {
                if (result.potentialImprovement > 0) {
                    const weight = sectionWeights[result.sectionName][type];
                    totalPotential += result.potentialImprovement * weight;
                    totalWeight += weight;
                }
            });
            return totalWeight > 0 ? (totalPotential / totalWeight) : 0;
        }

        function generateReport(name, business, crOverallImprovement, aovOverallImprovement, crResults, aovResults, mergedResults) {
            return `
                <h2>CR & AOV Growth Potential Report</h2>
                <p><strong>Prepared for:</strong> ${name} from ${business}</p>
                <p><strong>Date:</strong> ${new Date().toLocaleDateString()}</p>
                <h3>Summary</h3>
                <p>Your eCommerce store has the potential to improve:</p>
                <ul>
                    <li><strong>Conversion Rate (CR)</strong> by up to <strong>${crOverallImprovement.toFixed(1)}%</strong>.</li>
                    <li><strong>Average Order Value (AOV)</strong> by up to <strong>${aovOverallImprovement.toFixed(1)}%</strong>.</li>
                </ul>
                ${generateInsights(crResults, aovResults, mergedResults)}
                <p>We recommend focusing on the areas with the highest potential improvements first to maximize your gains.</p>
            `;
        }

            function generateInsights(crResults, aovResults, mergedResults) {
                let insights = '';
        
                // Highlight Strengths
                const strengths = mergedResults.filter(result => result.averageScore >= 4.0);
                if (strengths.length > 0) {
                    insights += '<h3>Strengths</h3>';
                    insights += '<p>The following areas are performing well:</p>';
                    insights += '<ul>';
                    strengths.forEach(result => {
                        insights += `<li>${result.sectionName}</li>`;
                    });
                    insights += '</ul>';
                } else {
                    insights += '<h3>Strengths</h3>';
                    insights += '<p>Based on your completed form, there are currently no core strengths on your website.</p>';
                }
            
                // Highlight Weaknesses
                const weaknesses = mergedResults.filter(result => result.averageScore <= 3.0);
                if (weaknesses.length > 0) {
                    insights += '<h3>Weaknesses</h3>';
                    insights += '<p>The following areas need attention:</p>';
                    insights += '<ul>';
                    weaknesses.forEach(result => {
                        insights += `<li>${result.sectionName}</li>`;
                    });
                    insights += '</ul>';
                } else {
                    insights += '<h3>Weaknesses</h3>';
                    insights += '<p>Based on your completed form, there are currently no core weaknesses on your website.</p>';
                }
        
            // Process CR Results
            insights += '<h3>Conversion Rate (CR) Improvement Priorities</h3>';
            const crPriorities = crResults.filter(result => result.potentialImprovement > 0);
            if (crPriorities.length > 0) {
                crPriorities.sort((a, b) => b.priorityScore - a.priorityScore);
                insights += '<ol>';
                crPriorities.forEach(result => {
                    insights += `
                        <li>
                            <p><strong>${result.sectionName}:</strong></p>
                            <p>${getRecommendationText(result.sectionName, 'CR')}</p>
                        </li>
                    `;
                });
                insights += '</ol>';
            } else {
                insights += '<p>No significant areas for improvement in Conversion Rate were identified.</p>';
            }
        
            // Process AOV Results
            insights += '<h3>Average Order Value (AOV) Improvement Priorities</h3>';
            const aovPriorities = aovResults.filter(result => result.potentialImprovement > 0);
            if (aovPriorities.length > 0) {
                aovPriorities.sort((a, b) => b.priorityScore - a.priorityScore);
                insights += '<ol>';
                aovPriorities.forEach(result => {
                    insights += `
                        <li>
                            <p><strong>${result.sectionName}:</strong></p>
                            <p>${getRecommendationText(result.sectionName, 'AOV')}</p>
                        </li>
                    `;
                });
                insights += '</ol>';
            } else {
                insights += '<p>No significant areas for improvement in Average Order Value were identified.</p>';
            }
        
            return insights;
        }

        function generateEmailRecommendations(results, type) {
            let recommendations = '';
            const filteredResults = results
                .filter(result => result.potentialImprovement > 0)
                .sort((a, b) => b.priorityScore - a.priorityScore);
        
            if (filteredResults.length > 0) {
                filteredResults.forEach(result => {
                    recommendations += `
                        <li>
                            <p><strong>${result.sectionName}</strong></p>
                            <p>${getRecommendationText(result.sectionName, type)}</p>
                        </li>
                    `;
                });
            } else {
                recommendations = `<p>No significant areas for improvement in ${type === 'CR' ? 'Conversion Rate' : 'Average Order Value'} were identified.</p>`;
            }
            return recommendations;
        }

        function getRecommendationText(sectionName, type) {
            const recommendations = {
                'Product Discovery and Navigation': {
                    'CR': 'Enhance your site search with autocomplete and predictive suggestions, improve product categorization, and simplify navigation to help users find products quickly, thereby increasing conversion rates.',
                    'AOV': 'Introduce product bundling and recommend complementary products during navigation to encourage customers to add more items to their cart, thus increasing average order value.'
                },
                'Social Proof and UGC': {
                    'CR': 'Prominently display customer reviews and ratings across your site to build trust and reduce purchase hesitation, leading to higher conversion rates.',
                    'AOV': 'Showcase user-generated content featuring premium products or bundles to inspire customers to consider higher-value purchases.'
                },
                'User Experience and Site Performance': {
                    'CR': 'Optimize website load times and ensure mobile responsiveness to provide a seamless experience, reducing bounce rates and improving conversions.',
                    'AOV': 'Incorporate interactive elements and high-quality visuals that can encourage customers to spend more time on site and explore higher-priced items.'
                },
                'Checkout Experience': {
                    'CR': 'Streamline your checkout process by minimizing required fields, offering guest checkout, and displaying trust signals to reduce cart abandonment.',
                    'AOV': 'Provide options for customers to easily add related products or services at checkout, such as gift wrapping or extended warranties, to increase order value.'
                },
                'Trust and Credibility': {
                    'CR': 'Display trust badges, security certificates, and transparent return policies to alleviate customer concerns and boost conversions.',
                    'AOV': 'Offer assurances like satisfaction guarantees or customer support for higher-priced items to make customers comfortable with larger purchases.'
                },
                'Upselling and Cross-selling Strategies': {
                    'CR': 'Recommend popular or trending products to visitors to increase the likelihood of a purchase.',
                    'AOV': 'Implement upselling and cross-selling techniques by suggesting higher-priced alternatives or complementary products to boost the average order value.'
                },
                'Personalization and Engagement': {
                    'CR': 'Use personalized content and product recommendations based on browsing history to present relevant products, enhancing the chance of conversion.',
                    'AOV': 'Tailor product suggestions to include premium items or bundles that align with customer interests, encouraging them to spend more.'
                },
                'Promotional Strategies': {
                    'CR': 'Create urgency with time-limited offers and entry discounts to motivate immediate purchases and improve conversion rates.',
                    'AOV': 'Implement gamified promotions like free shipping thresholds, free gifts with purchase, buy-more-save-more deals, and subscription options to incentivize customers to increase their cart value.'
                }
            };
            return recommendations[sectionName][type] || '';
        }

        function generateStrengths(mergedResults) {
            let strengths = '';
            const strongAreas = mergedResults.filter(result => result.averageScore >= 4.0);
            if (strongAreas.length > 0) {
                strengths += '<h3>Strengths</h3>';
                strengths += '<p>The following areas are performing well:</p>';
                strengths += '<ul>';
                strongAreas.forEach(result => {
                    strengths += `<li>${result.sectionName}</li>`;
                });
                strengths += '</ul>';
            } else {
                strengths += '<h3>Strengths</h3>';
                strengths += '<p>Based on your completed form, there are currently no core strengths on your website.</p>';
            }
            return strengths;
        }

        function generateWeaknesses(mergedResults) {
            let weaknesses = '';
            const weakAreas = mergedResults.filter(result => result.averageScore <= 3.0);
            if (weakAreas.length > 0) {
                weaknesses += '<h3>Weaknesses</h3>';
                weaknesses += '<p>The following areas need attention:</p>';
                weaknesses += '<ul>';
                weakAreas.forEach(result => {
                    weaknesses += `<li>${result.sectionName}</li>`;
                });
                weaknesses += '</ul>';
            } else {
                weaknesses += '<h3>Weaknesses</h3>';
                weaknesses += '<p>Based on your completed form, there are currently no core weaknesses on your website.</p>';
            }
            return weaknesses;
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-region-switcher"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const preference = (() => {
      if (window.BlendRegionPreference) return window.BlendRegionPreference;
      const promptSuppressedUntilKey = 'blend_region_prompt_suppressed_until_v1';
      const selectedRegionKey = 'blend_region_selected_region_v1';
      const legacyDismissKey = 'blend_region_prompt_dismissed_session_v1';
      const legacySelectedRegionKey = 'blend_region_selected_region_session_v1';
      const channelName = 'blend_region_preference_v1';
      const suppressionDurationMs = 24 * 60 * 60 * 1000;
      const subscribers = new Set();
      let channel = null;

      function safeLocalGet(key) { try { return window.localStorage.getItem(key); } catch (error) { return null; } }
      function safeLocalSet(key, value) { try { window.localStorage.setItem(key, value); } catch (error) { return; } }
      function safeLocalRemove(key) { try { window.localStorage.removeItem(key); } catch (error) { return; } }
      function safeSessionGet(key) { try { return window.sessionStorage.getItem(key); } catch (error) { return null; } }
      function isRegionCode(region) { return region === 'US' || region === 'GB' || region === 'AU' || region === 'ROW'; }
      function getSuppressedUntil() { const value = Number.parseInt(safeLocalGet(promptSuppressedUntilKey), 10); return Number.isFinite(value) ? value : 0; }
      function clearExpiredSuppression() { const until = getSuppressedUntil(); if (until && Date.now() >= until) { safeLocalRemove(promptSuppressedUntilKey); safeLocalRemove(selectedRegionKey); } }
      function getSelectedRegion() { clearExpiredSuppression(); const region = safeLocalGet(selectedRegionKey) || safeSessionGet(legacySelectedRegionKey); return isRegionCode(region) ? region : null; }
      function isPromptSuppressed() { clearExpiredSuppression(); if (getSuppressedUntil() > Date.now()) return true; return safeSessionGet(legacyDismissKey) === 'true'; }
      function notify(message) { subscribers.forEach((callback) => { try { callback(message); } catch (error) { return; } }); }
      function emit(payload) { const message = Object.assign({ source: 'blend-region-preference', createdAt: Date.now() }, payload); notify(message); if (channel) { try { channel.postMessage(message); } catch (error) { return; } } }
      function suppressPrompt(options) {
        const settings = options || {};
        const suppressedUntil = Date.now() + suppressionDurationMs;
        const region = isRegionCode(settings.region) ? settings.region : null;
        safeLocalSet(promptSuppressedUntilKey, String(suppressedUntil));
        if (region) safeLocalSet(selectedRegionKey, region);
        emit({ type: 'regionPromptSuppressed', reason: settings.reason || 'manual', region: region, suppressedUntil: suppressedUntil });
      }
      function rememberRegionSelection(region, reason) { suppressPrompt({ region: region, reason: reason || 'region_selection' }); }
      function onChange(callback) { subscribers.add(callback); return () => subscribers.delete(callback); }

      try {
        channel = new BroadcastChannel(channelName);
        channel.addEventListener('message', (event) => {
          if (!event.data || event.data.source !== 'blend-region-preference') return;
          notify(event.data);
        });
      } catch (error) {
        channel = null;
      }

      window.addEventListener('storage', (event) => {
        if (event.key !== promptSuppressedUntilKey && event.key !== selectedRegionKey) return;
        notify({ source: 'blend-region-preference', type: 'regionPreferenceStorageChanged', region: getSelectedRegion(), suppressedUntil: getSuppressedUntil(), createdAt: Date.now() });
      });

      window.BlendRegionPreference = { getSelectedRegion: getSelectedRegion, isPromptSuppressed: isPromptSuppressed, isRegionCode: isRegionCode, onChange: onChange, rememberRegionSelection: rememberRegionSelection, suppressPrompt: suppressPrompt };
      return window.BlendRegionPreference;
    })();
    const regions = {
      US: { label: 'United States', flag: '🇺🇸', countries: ['US'] },
      GB: { label: 'United Kingdom', flag: '🇬🇧', countries: ['GB'] },
      AU: { label: 'Australia', flag: '🇦🇺', countries: ['AU'] },
      ROW: { label: 'Rest of the World', flag: '🌐', countries: [] }
    };

    function isRegionCode(region) { return preference.isRegionCode(region); }
    function getBasePath() {
      const path = window.location.pathname || '/';
      const lowerPath = path.toLowerCase();
      if (lowerPath === '/en-au' || lowerPath === '/en-gb') return '/';
      if (lowerPath.startsWith('/en-au/')) return path.slice(6) || '/';
      if (lowerPath.startsWith('/en-gb/')) return path.slice(6) || '/';
      return path;
    }
    function buildRegionUrl(region) {
      const basePath = getBasePath();
      const suffix = window.location.search + window.location.hash;
      let prefix = '';
      if (region === 'AU') prefix = '/en-au';
      if (region === 'GB') prefix = '/en-gb';
      if (!prefix) return basePath + suffix;
      return (basePath === '/' ? prefix : prefix + basePath) + suffix;
    }
    function updateRegionLinks(root) {
      root.querySelectorAll('[data-region-switcher-link][data-region-option]').forEach((link) => {
        link.setAttribute('href', buildRegionUrl(link.getAttribute('data-region-option')));
      });
    }
    function getCurrentRegion() {
      const path = window.location.pathname.toLowerCase();
      const selectedRegion = preference.getSelectedRegion();
      if (path === '/en-au' || path.startsWith('/en-au/')) return 'AU';
      if (path === '/en-gb' || path.startsWith('/en-gb/')) return 'GB';
      if (selectedRegion === 'US' || selectedRegion === 'ROW') return selectedRegion;
      if (window.Shopify && window.Shopify.country === 'US') return 'US';
      return 'ROW';
    }
    function getTargetRegion(countryCode) {
      const country = String(countryCode || '').toUpperCase();
      if (regions.AU.countries.includes(country)) return 'AU';
      if (regions.GB.countries.includes(country)) return 'GB';
      if (regions.US.countries.includes(country)) return 'US';
      return 'ROW';
    }
    function getSuggestionsUrl() {
      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      const prefix = root.endsWith('/') ? root : root + '/';
      const currentCountry = window.Shopify && window.Shopify.country ? window.Shopify.country : getCurrentRegion();
      return prefix + 'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(currentCountry);
    }
    async function getDetectedCountry() {
      const params = new URLSearchParams(window.location.search);
      const forcedRegion = params.get('region_prompt_debug');
      if (isRegionCode(forcedRegion)) return forcedRegion;
      if (!window.Shopify) return null;
      const response = await fetch(getSuggestionsUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return null;
      const data = await response.json();
      const detected = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
      const suggested = data && data.suggestions && data.suggestions[0] && data.suggestions[0].parts && data.suggestions[0].parts.country && data.suggestions[0].parts.country.handle;
      return detected || suggested || null;
    }
    function applyRegionState(currentRegion, targetRegion) {
      const switcher = document.querySelector('[data-footer-region-switcher]');
      if (!switcher) return;
      updateRegionLinks(switcher);
      const current = regions[currentRegion] || regions.ROW;
      const summaryFlag = switcher.querySelector('[data-region-summary-flag]');
      const summaryLabel = switcher.querySelector('[data-region-summary-label]');
      if (summaryFlag) summaryFlag.textContent = current.flag;
      if (summaryLabel) summaryLabel.textContent = current.label;

      switcher.querySelectorAll('[data-region-option]').forEach((option) => {
        const optionRegion = option.getAttribute('data-region-option');
        const currentBadge = option.querySelector('[data-current-badge]');
        const recommendedBadge = option.querySelector('[data-recommended-badge]');
        const isCurrent = optionRegion === currentRegion;
        const isRecommended = optionRegion === targetRegion && optionRegion !== currentRegion;
        option.classList.toggle('is-active', isCurrent);
        option.classList.toggle('is-recommended', isRecommended);
        if (isCurrent) option.setAttribute('aria-current', 'true');
        else option.removeAttribute('aria-current');
        if (currentBadge) currentBadge.hidden = !isCurrent;
        if (recommendedBadge) recommendedBadge.hidden = !isRecommended;
      });
    }
    function moveFooterRegionSwitcher() {
      const switcher = document.querySelector('[data-footer-region-switcher]');
      const target = document.querySelector('.footer-block__brand-info');
      if (!switcher || !target || target.contains(switcher)) return;
      target.appendChild(switcher);
    }
    async function updateFooterRecommendation() {
      const currentRegion = getCurrentRegion();
      let targetRegion = currentRegion;
      try {
        targetRegion = getTargetRegion(await getDetectedCountry());
      } catch (error) {
        targetRegion = currentRegion;
      }
      applyRegionState(currentRegion, targetRegion);
    }
    function init() {
      moveFooterRegionSwitcher();
      updateFooterRecommendation();
    }

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-region-switcher-link]');
      if (!link) return;
      link.setAttribute('href', buildRegionUrl(link.getAttribute('data-region-option')));
      preference.rememberRegionSelection(link.getAttribute('data-region-option'), 'footer_region_switcher_click');
      const details = link.closest('details');
      if (details) details.open = false;
    }, true);

    preference.onChange(updateFooterRecommendation);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
if (!customElements.get('blend-footer-newsletter')) {
  class BlendFooterNewsletter extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true') return;
      this.loadController?.abort();
      this.loadController = new AbortController();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.prepareForm(), {
          once: true,
          signal: this.loadController.signal
        });
      } else {
        this.prepareForm();
      }
    }

    disconnectedCallback() {
      this.loadController?.abort();
      this.visibilityObserver?.disconnect();
      this.formObserver?.disconnect();
    }

    formUrl() {
      let url;
      try { url = new URL(this.dataset.src); } catch { return null; }
      return url.origin === 'https://subscribe-forms.beehiiv.com' && /\/([a-f0-9-]{36})\/?$/i.test(url.pathname) ? url : null;
    }

    loadAttribution() {
      if (document.querySelector('script[src="https://subscribe-forms.beehiiv.com/attribution.js"]')) return;
      const attribution = document.createElement('script');
      attribution.async = true;
      attribution.src = 'https://subscribe-forms.beehiiv.com/attribution.js';
      document.head.append(attribution);
    }

    prepareForm() {
      if (this.dataset.loaded === 'true' || !this.isConnected) return;
      const url = this.formUrl();
      if (!url) return;
      this.dataset.src = url.href;
      const fallback = this.querySelector('.blend-footer__form-fallback');
      if (fallback) fallback.href = url.href;
      this.loadAttribution();
      const signal = this.loadController.signal;
      ['focusin', 'pointerdown'].forEach((event) => {
        this.addEventListener(event, () => this.mountForm(), { once: true, signal });
      });
      if (typeof IntersectionObserver !== 'function') {
        this.mountForm();
        return;
      }
      this.visibilityObserver?.disconnect();
      this.visibilityObserver = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.mountForm();
      }, { rootMargin: '800px 0px' });
      this.visibilityObserver.observe(this);
    }

    mountForm() {
      if (this.dataset.loaded === 'true' || !this.isConnected) return;
      const url = this.formUrl();
      if (!url) return;
      const id = url.pathname.match(/\/([a-f0-9-]{36})\/?$/i)[1];
      this.dataset.loaded = 'true';
      this.dataset.src = url.href;
      this.visibilityObserver?.disconnect();
      const fallback = this.querySelector('.blend-footer__form-fallback');
      if (fallback) fallback.href = url.href;
      this.loadAttribution();
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://subscribe-forms.beehiiv.com/v3/loader.js';
      script.dataset.beehiivForm = id;
      script.addEventListener('error', () => {
        if (fallback) this.replaceChildren(fallback);
        this.dataset.formReady = 'false';
      }, { once: true });
      this.formObserver = new MutationObserver(() => {
        const frame = this.querySelector('iframe');
        if (!frame) return;
        frame.title = this.dataset.formTitle;
        frame.loading = 'eager';
        this.dataset.formReady = 'true';
        const fallbackHadFocus = fallback === document.activeElement;
        fallback?.remove();
        if (fallbackHadFocus) frame.focus({ preventScroll: true });
        this.formObserver.disconnect();
      });
      this.formObserver.observe(this, { childList: true, subtree: true });
      this.append(script);
    }
  }
  customElements.define('blend-footer-newsletter', BlendFooterNewsletter);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["region-recommendation-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const popup = document.querySelector('[data-region-recommendation-popup]');
    if (!popup || !window.Shopify) return;
    const modalLockKey = '__blendRegionPromptOpen';
    const promptDelayMs = Math.max(0, Number.parseInt(popup.getAttribute('data-region-popup-delay-ms'), 10) || 0);
    const competingSelectors = '[aria-modal="true"], [role="dialog"], .modal, .popup, .newsletter-popup, .exit-intent, iframe[src*="beehiiv"], iframe[src*="subscribe-forms"], [src*="beehiiv"], [src*="subscribe-forms"], [id*="beehiiv"], [class*="beehiiv"], [id*="bhv"], [class*="bhv"], [data-bhv], [class*="klaviyo"], [id*="klaviyo"], [class*="Klaviyo"], [id*="Klaviyo"], [class*="needsclick"], [class*="omnisend"], [id*="omnisend"]';
    const beehiivSelectors = 'iframe[src*="beehiiv"], iframe[src*="subscribe-forms"], [src*="beehiiv"], [src*="subscribe-forms"], [id*="beehiiv"], [class*="beehiiv"], [id*="bhv"], [class*="bhv"], [data-bhv]';
    const exitIntentEvents = ['mouseout', 'mouseleave', 'pointerout', 'pointerleave', 'mousemove', 'blur'];
    const regions = { US: { countries: ['US'] }, AU: { countries: ['AU'] }, GB: { countries: ['GB'] } };
    let pendingPrompt = false;
    let conflictObserver = null;
    let exitIntentBlockers = [];
    let promptDelayTimer = null;
    const preference = (() => {
      if (window.BlendRegionPreference) return window.BlendRegionPreference;
      const promptSuppressedUntilKey = 'blend_region_prompt_suppressed_until_v1';
      const selectedRegionKey = 'blend_region_selected_region_v1';
      const legacyDismissKey = 'blend_region_prompt_dismissed_session_v1';
      const legacySelectedRegionKey = 'blend_region_selected_region_session_v1';
      const channelName = 'blend_region_preference_v1';
      const suppressionDurationMs = 24 * 60 * 60 * 1000;
      const subscribers = new Set();
      let channel = null;

      function safeLocalGet(key) { try { return window.localStorage.getItem(key); } catch (error) { return null; } }
      function safeLocalSet(key, value) { try { window.localStorage.setItem(key, value); } catch (error) { return; } }
      function safeLocalRemove(key) { try { window.localStorage.removeItem(key); } catch (error) { return; } }
      function safeSessionGet(key) { try { return window.sessionStorage.getItem(key); } catch (error) { return null; } }
      function isRegionCode(region) { return region === 'US' || region === 'GB' || region === 'AU' || region === 'ROW'; }
      function getSuppressedUntil() { const value = Number.parseInt(safeLocalGet(promptSuppressedUntilKey), 10); return Number.isFinite(value) ? value : 0; }
      function clearExpiredSuppression() { const until = getSuppressedUntil(); if (until && Date.now() >= until) { safeLocalRemove(promptSuppressedUntilKey); safeLocalRemove(selectedRegionKey); } }
      function getSelectedRegion() { clearExpiredSuppression(); const region = safeLocalGet(selectedRegionKey) || safeSessionGet(legacySelectedRegionKey); return isRegionCode(region) ? region : null; }
      function isPromptSuppressed() { clearExpiredSuppression(); if (getSuppressedUntil() > Date.now()) return true; return safeSessionGet(legacyDismissKey) === 'true'; }
      function notify(message) { subscribers.forEach((callback) => { try { callback(message); } catch (error) { return; } }); }
      function emit(payload) { const message = Object.assign({ source: 'blend-region-preference', createdAt: Date.now() }, payload); notify(message); if (channel) { try { channel.postMessage(message); } catch (error) { return; } } }
      function suppressPrompt(options) {
        const settings = options || {};
        const suppressedUntil = Date.now() + suppressionDurationMs;
        const region = isRegionCode(settings.region) ? settings.region : null;
        safeLocalSet(promptSuppressedUntilKey, String(suppressedUntil));
        if (region) safeLocalSet(selectedRegionKey, region);
        emit({ type: 'regionPromptSuppressed', reason: settings.reason || 'manual', region: region, suppressedUntil: suppressedUntil });
      }
      function rememberRegionSelection(region, reason) { suppressPrompt({ region: region, reason: reason || 'region_selection' }); }
      function onChange(callback) { subscribers.add(callback); return () => subscribers.delete(callback); }

      try {
        channel = new BroadcastChannel(channelName);
        channel.addEventListener('message', (event) => {
          if (!event.data || event.data.source !== 'blend-region-preference') return;
          notify(event.data);
        });
      } catch (error) {
        channel = null;
      }

      window.addEventListener('storage', (event) => {
        if (event.key !== promptSuppressedUntilKey && event.key !== selectedRegionKey) return;
        notify({ source: 'blend-region-preference', type: 'regionPreferenceStorageChanged', region: getSelectedRegion(), suppressedUntil: getSuppressedUntil(), createdAt: Date.now() });
      });

      window.BlendRegionPreference = { getSelectedRegion: getSelectedRegion, isPromptSuppressed: isPromptSuppressed, isRegionCode: isRegionCode, onChange: onChange, rememberRegionSelection: rememberRegionSelection, suppressPrompt: suppressPrompt };
      return window.BlendRegionPreference;
    })();
    function isRegionCode(region) { return preference.isRegionCode(region); }
    function isDismissed() { return preference.isPromptSuppressed(); }
    function isPopupOpen() { return !popup.hidden; }
    function getBasePath() {
      const path = window.location.pathname || '/';
      const lowerPath = path.toLowerCase();
      if (lowerPath === '/en-au' || lowerPath === '/en-gb') return '/';
      if (lowerPath.startsWith('/en-au/')) return path.slice(6) || '/';
      if (lowerPath.startsWith('/en-gb/')) return path.slice(6) || '/';
      return path;
    }
    function buildRegionUrl(region) {
      const basePath = getBasePath();
      const suffix = window.location.search + window.location.hash;
      let prefix = '';
      if (region === 'AU') prefix = '/en-au';
      if (region === 'GB') prefix = '/en-gb';
      if (!prefix) return basePath + suffix;
      return (basePath === '/' ? prefix : prefix + basePath) + suffix;
    }
    function updateRegionLinks() {
      popup.querySelectorAll('[data-region-switcher-link][data-region-option]').forEach((link) => {
        link.setAttribute('href', buildRegionUrl(link.getAttribute('data-region-option')));
      });
    }
    function getCurrentRegion() {
      const path = window.location.pathname.toLowerCase();
      const selectedRegion = preference.getSelectedRegion();
      if (path === '/en-au' || path.startsWith('/en-au/')) return 'AU';
      if (path === '/en-gb' || path.startsWith('/en-gb/')) return 'GB';
      if (selectedRegion === 'US' || selectedRegion === 'ROW') return selectedRegion;
      if (window.Shopify.country === 'US') return 'US';
      return 'ROW';
    }
    function getTargetRegion(countryCode) {
      const country = String(countryCode || '').toUpperCase();
      if (regions.AU.countries.includes(country)) return 'AU';
      if (regions.GB.countries.includes(country)) return 'GB';
      if (regions.US.countries.includes(country)) return 'US';
      return 'ROW';
    }
    function getSuggestionsUrl() {
      const root = window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      const prefix = root.endsWith('/') ? root : root + '/';
      const currentCountry = window.Shopify.country || getCurrentRegion();
      return prefix + 'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(currentCountry);
    }
    async function getDetectedCountry() {
      const params = new URLSearchParams(window.location.search);
      const forcedRegion = params.get('region_prompt_debug');
      if (isRegionCode(forcedRegion)) return forcedRegion;
      const response = await fetch(getSuggestionsUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return null;
      const data = await response.json();
      const detected = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
      const suggested = data && data.suggestions && data.suggestions[0] && data.suggestions[0].parts && data.suggestions[0].parts.country && data.suggestions[0].parts.country.handle;
      return detected || suggested || null;
    }
    function setBadges(currentRegion, targetRegion) {
      popup.querySelectorAll('[data-region-option]').forEach((option) => {
        const optionRegion = option.getAttribute('data-region-option');
        const currentBadge = option.querySelector('[data-current-badge]');
        const recommendedBadge = option.querySelector('[data-recommended-badge]');
        const isCurrent = optionRegion === currentRegion;
        const isRecommended = optionRegion === targetRegion && optionRegion !== currentRegion;
        option.classList.toggle('is-current', isCurrent);
        option.classList.toggle('is-recommended', isRecommended);
        if (currentBadge) currentBadge.hidden = !isCurrent;
        if (recommendedBadge) recommendedBadge.hidden = !isRecommended;
      });
    }
    function isVisibleElement(element) { if (!element || element === popup || popup.contains(element)) return false; const style = window.getComputedStyle(element); if (style.display === 'none' || style.visibility === 'hidden' || style.pointerEvents === 'none' || Number(style.opacity) === 0) return false; const rect = element.getBoundingClientRect(); if (rect.width < 1 || rect.height < 1) return false; if (rect.bottom <= 0 || rect.right <= 0 || rect.top >= window.innerHeight || rect.left >= window.innerWidth) return false; return true; }
    function getElementIdentity(element) { return `${element.id || ''} ${element.className || ''} ${element.getAttribute('src') || ''}`; }
    function getNumericZIndex(element) { const value = window.getComputedStyle(element).zIndex; const zIndex = Number.parseInt(value, 10); return Number.isFinite(zIndex) ? zIndex : 0; }
    function isFullscreenOverlay(element) { if (!isVisibleElement(element)) return false; const style = window.getComputedStyle(element); if (style.position !== 'fixed') return false; if (getNumericZIndex(element) < 100000) return false; const rect = element.getBoundingClientRect(); const coversViewport = rect.width >= window.innerWidth * 0.75 && rect.height >= window.innerHeight * 0.75 && rect.left <= 40 && rect.top <= 40; const background = style.backgroundColor || ''; const hasBackdrop = background !== '' && background !== 'transparent' && background !== 'rgba(0, 0, 0, 0)'; return coversViewport && hasBackdrop; }
    function isVisibleCompetingPopup(element) { if (!isVisibleElement(element)) return false; const style = window.getComputedStyle(element); const rect = element.getBoundingClientRect(); if (rect.width < 120 || rect.height < 80) return false; const identity = getElementIdentity(element); const modalLike = element.getAttribute('role') === 'dialog' || element.getAttribute('aria-modal') === 'true' || /modal|popup|beehiiv|bhv|subscribe-forms|exit|newsletter|klaviyo|needsclick|omnisend/i.test(identity); const overlayLike = style.position === 'fixed' || style.position === 'sticky' || style.position === 'absolute' || getNumericZIndex(element) >= 1000; return modalLike && overlayLike; }
    function getVisibleBeehiivOverlays() { const overlays = []; const markers = Array.from(document.querySelectorAll(beehiivSelectors)); markers.forEach((marker) => { let element = marker; for (let depth = 0; element && depth < 8; depth += 1) { if (isVisibleCompetingPopup(element) || isFullscreenOverlay(element)) { overlays.push(element); break; } element = element.parentElement; } }); return Array.from(new Set(overlays)); }
    function hasVisibleBeehiivPopup() { return getVisibleBeehiivOverlays().length > 0; }
    function suppressVisibleBeehiivPopups() { const overlays = getVisibleBeehiivOverlays(); overlays.forEach((element) => { element.setAttribute('aria-hidden', 'true'); element.style.setProperty('display', 'none', 'important'); element.style.setProperty('visibility', 'hidden', 'important'); }); return overlays.length > 0; }
    function hasVisibleCompetingPopup() { const targeted = Array.from(document.querySelectorAll(competingSelectors)).some((element) => isVisibleCompetingPopup(element) || isFullscreenOverlay(element)); const fullscreen = Array.from(document.body.children).some(isFullscreenOverlay); return targeted || fullscreen || hasVisibleBeehiivPopup(); }
    function shouldBlockExitIntentEvent(event) { if (!isPopupOpen()) return false; if (event.type === 'mousemove') return typeof event.clientY === 'number' && event.clientY <= 8; if (event.type === 'mouseout' || event.type === 'pointerout') return event.relatedTarget === null; return true; }
    function blockExitIntentEvent(event) { if (!shouldBlockExitIntentEvent(event)) return; event.stopImmediatePropagation(); }
    function addExitIntentBlocker(target, type) { target.addEventListener(type, blockExitIntentEvent, true); exitIntentBlockers.push({ target: target, type: type, handler: blockExitIntentEvent }); }
    function enableModalLock() { window[modalLockKey] = true; if (exitIntentBlockers.length) return; exitIntentEvents.forEach((type) => addExitIntentBlocker(window, type)); exitIntentEvents.forEach((type) => addExitIntentBlocker(document, type)); addExitIntentBlocker(document, 'visibilitychange'); }
    function disableModalLock() { window[modalLockKey] = false; exitIntentBlockers.forEach((entry) => entry.target.removeEventListener(entry.type, entry.handler, true)); exitIntentBlockers = []; }
    function clearPromptDelay() { if (!promptDelayTimer) return; window.clearTimeout(promptDelayTimer); promptDelayTimer = null; }
    function hidePrompt() { pendingPrompt = false; clearPromptDelay(); disableModalLock(); popup.hidden = true; document.documentElement.classList.remove('region-recommendation-popup-open'); }
    function suppressForDay(reason) { preference.suppressPrompt({ reason: reason || 'popup_dismissed' }); hidePrompt(); }
    function openPopup() { popup.hidden = false; document.documentElement.classList.add('region-recommendation-popup-open'); enableModalLock(); suppressVisibleBeehiivPopups(); const closeButton = popup.querySelector('[data-region-popup-close]'); if (closeButton) closeButton.focus({ preventScroll: true }); }
    function closePopup() { suppressForDay('popup_dismissed'); }
    function attemptOpen() { promptDelayTimer = null; if (!pendingPrompt || isDismissed()) return; if (hasVisibleCompetingPopup()) { suppressForDay('competing_popup_visible'); return; } openPopup(); }
    function scheduleOpen() { clearPromptDelay(); if (promptDelayMs > 0) { promptDelayTimer = window.setTimeout(attemptOpen, promptDelayMs); return; } attemptOpen(); }
    function handlePopupConflicts() { if (!pendingPrompt || isDismissed()) return; if (isPopupOpen()) { if (suppressVisibleBeehiivPopups()) return; if (hasVisibleCompetingPopup()) suppressForDay('competing_popup_visible'); return; } if (hasVisibleCompetingPopup()) suppressForDay('competing_popup_visible'); }
    function watchForPopupConflicts() { if (conflictObserver) return; conflictObserver = new MutationObserver(handlePopupConflicts); conflictObserver.observe(document.body, { attributes: true, childList: true, subtree: true, attributeFilter: ['aria-hidden', 'aria-modal', 'class', 'hidden', 'role', 'src', 'style'] }); }
    preference.onChange(hidePrompt);
    popup.addEventListener('click', (event) => { if (event.target === popup || event.target.closest('[data-region-popup-close]')) closePopup(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !popup.hidden) closePopup(); });
    document.addEventListener('click', (event) => { const link = event.target.closest('[data-region-switcher-link]'); if (!link) return; link.setAttribute('href', buildRegionUrl(link.getAttribute('data-region-option'))); preference.rememberRegionSelection(link.getAttribute('data-region-option'), 'region_switcher_click'); }, true);
    async function init() { updateRegionLinks(); if (isDismissed()) return; try { const currentRegion = getCurrentRegion(); const detectedCountry = await getDetectedCountry(); if (isDismissed()) return; const targetRegion = getTargetRegion(detectedCountry); if (targetRegion === currentRegion) return; setBadges(currentRegion, targetRegion); pendingPrompt = true; watchForPopupConflicts(); scheduleOpen(); } catch (error) { return; } }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roi-calculator"] && !Shopify.designMode) return;
  try {
    
    (function(){
        emailjs.init("2i48htRz-HRDWM8kH"); // Your Public Key
    })();
    document.addEventListener('DOMContentLoaded', function () {
        // Initialize variables for toggles
        let increaseCR = 22.5; // Initial Conversion Rate Increase (%)
        let increaseAOV = 15.0; // Initial AOV Increase (%)

        // Update the display values for toggles
        document.getElementById('increaseCRValue').value = increaseCR;
        document.getElementById('increaseAOVValue').value = increaseAOV;

        // Conversion Rate Increase Toggle Buttons
        document.getElementById('crPlus').addEventListener('click', function () {
            if (increaseCR < 100) {
                increaseCR += 2.5;
                document.getElementById('increaseCRValue').value = increaseCR;
            }
        });

        document.getElementById('crMinus').addEventListener('click', function () {
            if (increaseCR > 0) {
                increaseCR -= 2.5;
                document.getElementById('increaseCRValue').value = increaseCR;
            }
        });

        // AOV Increase Toggle Buttons
        document.getElementById('aovPlus').addEventListener('click', function () {
            if (increaseAOV < 100) {
                increaseAOV += 2.5;
                document.getElementById('increaseAOVValue').value = increaseAOV;
            }
        });

        document.getElementById('aovMinus').addEventListener('click', function () {
            if (increaseAOV > 0) {
                increaseAOV -= 2.5;
                document.getElementById('increaseAOVValue').value = increaseAOV;
            }
        });

        // Define conversion rates for different currencies
        const exchangeRates = {
            'USD': 1,     // Base currency
            'EUR': 0.937,
            'GBP': 0.7499,
            'AUD': 1.5
        };

        // Handle form submission
        document.getElementById('roiForm').addEventListener('submit', function (e) {
            e.preventDefault();

            // Collect input values
            const totalRevenue = parseFloat(document.getElementById('totalRevenue').value);
            const currentCR = parseFloat(document.getElementById('currentCR').value);
            const averageOrderValue = parseFloat(document.getElementById('averageOrderValue').value);
            const profitRatio = parseFloat(document.getElementById('profitRatio').value);
            const email = document.getElementById('email').value;
            const consent = document.getElementById('consent').checked;
            const clientName = document.getElementById('clientName').value;
            const clientBusiness = document.getElementById('clientBusiness').value;
            const selectedCurrency = document.getElementById('Select-currency').value;

            if (!validateEmail(email) || !consent) {
                alert("Please provide valid inputs and agree to the consent.");
                return;
            }

            // User-defined target metrics from toggles
            const targetCRIncrease = increaseCR / 100;
            const targetAOVIncrease = increaseAOV / 100;

            // Calculate traffic
            const traffic = totalRevenue / (currentCR / 100 * averageOrderValue);

            // Initial monthly growth rates to reach target increases in 12 months
            const monthlyCRGrowth = Math.pow(1 + targetCRIncrease, 1 / 12) - 1;
            const monthlyAOVGrowth = Math.pow(1 + targetAOVIncrease, 1 / 12) - 1;

            let currentCRValue = currentCR;
            let currentAOVValue = averageOrderValue;

            // Convert CRO program cost to the selected currency
            const selectedCurrencyRate = exchangeRates[selectedCurrency] || 1;
            const minMonthCost = 3999 * selectedCurrencyRate;
            const maxMonthCost = 11999 * selectedCurrencyRate;
            const perMonthCost = totalRevenue / 100 * 1.5 * selectedCurrencyRate;
            
            let monthlyCROCost = 0;
            
            if (perMonthCost >= maxMonthCost) {
            monthlyCROCost = maxMonthCost;
            } else if (perMonthCost <= minMonthCost) {
            monthlyCROCost = minMonthCost;
            } else {
            monthlyCROCost = perMonthCost;
            }
            const auditCost = 3999 * selectedCurrencyRate;
            const programCost12 = monthlyCROCost * 12 + auditCost;
            const programCost36 = monthlyCROCost * 36 + auditCost;
            const programCost60 = monthlyCROCost * 60 + auditCost;

            let cumulativeRevenue = 0;
            let cumulativeProfit = 0;

            const monthlyData = [];
            let cumulativeProfit12 = 0;
            let cumulativeProfit36 = 0;
            let cumulativeProfit60 = 0;

            for (let month = 1; month <= 60; month++) {
                let currentMonthlyCRGrowth, currentMonthlyAOVGrowth;

                if (month <= 12) {
                    // Months 1-12: Use initial monthly growth rates
                    currentMonthlyCRGrowth = monthlyCRGrowth;
                    currentMonthlyAOVGrowth = monthlyAOVGrowth;
                } else {
                    // Months 13-60: Decrease growth rates linearly to zero
                    const monthsSince12 = month - 12;
                    const totalMonthsAfter12 = 48; // Months 13 to 60
                    const decreasingFactor = 1 - (monthsSince12 / totalMonthsAfter12);

                    currentMonthlyCRGrowth = monthlyCRGrowth * decreasingFactor;
                    currentMonthlyAOVGrowth = monthlyAOVGrowth * decreasingFactor;
                }

                // Update current CR and AOV values
                currentCRValue *= (1 + currentMonthlyCRGrowth);
                currentAOVValue *= (1 + currentMonthlyAOVGrowth);

                // Calculate new revenue and profits
                const newRevenue = traffic * (currentCRValue / 100) * currentAOVValue;
                const extraRevenue = newRevenue - totalRevenue;
                const monthlyProfit = extraRevenue * (profitRatio / 100);

                cumulativeRevenue += extraRevenue;
                cumulativeProfit += monthlyProfit;

                // Store cumulative profits at specific milestones
                if (month === 12) cumulativeProfit12 = cumulativeProfit;
                if (month === 36) cumulativeProfit36 = cumulativeProfit;
                if (month === 60) cumulativeProfit60 = cumulativeProfit;

                const cumulativeCost = monthlyCROCost * month;
                const monthlyROI = ((cumulativeProfit - cumulativeCost) / cumulativeCost) * 100;

                monthlyData.push({
                    month,
                    cr: currentCRValue.toFixed(2),
                    aov: formatCurrency(currentAOVValue, selectedCurrency),
                    revenue: formatCurrency(newRevenue, selectedCurrency),
                    cumulativeRevenue: formatCurrency(cumulativeRevenue, selectedCurrency),
                    cumulativeProfit: formatCurrency(cumulativeProfit, selectedCurrency),
                    roi: monthlyROI.toFixed(2)
                });
            }

            // Find breakeven month
            let breakevenMonth = monthlyData.findIndex((data, index) => {
                if (index > 0) {
                    const cumulativeCostAtMonth = monthlyCROCost * index;
                    return parseFloat(data.cumulativeProfit.replace(/[^0-9.-]+/g, "")) >= cumulativeCostAtMonth;
                }
                return false;
            });

            breakevenMonth = breakevenMonth >= 0 ? breakevenMonth + 1 : "No breakeven point within 60 months";

            const roi12 = ((cumulativeProfit12 - programCost12) / programCost12) * 100;
            const roi36 = ((cumulativeProfit36 - programCost36) / programCost36) * 100;
            const roi60 = ((cumulativeProfit60 - programCost60) / programCost60) * 100;

            const breakevenMessage = breakevenMonth !== "No breakeven point within 60 months"
                ? `Based on the indicated target Conversion Rate and the Target Average Order Value, we calculate that you would break even on this program in Month ${breakevenMonth}.`
                : `Based on the indicated target Conversion Rate and the Target Average Order Value, it appears you would not break even within the next 5 years due to diminishing returns.`;

            // Generate the report
            const reportString = `
            <h2>CRO Program ROI Report</h2>
            <p><strong>Prepared for:</strong> ${clientName} from ${clientBusiness}</p>
            <p><strong>Prepared by:</strong> Blend Commerce</p>
            <p><strong>Date:</strong> ${new Date().toLocaleDateString()}</p>
            <p>This report provides a detailed projection of the expected impact of an investment in a CRO program. It highlights key performance metrics such as the breakeven point, monthly revenue projections, cumulative additional revenue, and ROI over 1, 3, and 5 years.</p>
            <p><strong>Note:</strong> This report takes into account the natural slowing of growth over time as the website becomes more Optimised. As a site reaches a higher level of optimization, further improvements become more challenging to achieve significant gains. Additionally, this report does not consider the potential impact of improving other core growth metrics, such as Purchase Frequency, Customer Retention Rate, and Customer Acquisition Costs, which can also play a significant role in overall business growth.</p>
            
            <h3>Current Situation</h3>
            <ul>
                <li><strong>Current Monthly Revenue:</strong> ${formatCurrency(totalRevenue, selectedCurrency)}</li>
                <li><strong>Current Conversion Rate (CR):</strong> ${currentCR}%</li>
                <li><strong>Current Average Order Value (AOV):</strong> ${formatCurrency(averageOrderValue, selectedCurrency)}</li>
                <li><strong>Net Profit Margin:</strong> ${profitRatio}%</li>
            </ul>
            
            <h3>Targeted Metrics after 1 Year of a CRO program:</h3>
            <ul>
                <li><strong>Target Monthly Revenue:</strong> ${monthlyData[11].revenue}</li>
                <li><strong>Target Conversion Rate:</strong> ${(monthlyData[11].cr)}%</li>
                <li><strong>Target AOV:</strong> ${monthlyData[11].aov}</li>
            </ul>
            
            <h3>Revenue & ROI Projections</h3>
            <p><strong>Breakeven:</strong> ${breakevenMessage}</p>
            
            <p><strong>Year 1 Projections:</strong></p>
            <ul>
                <li><strong>Projected Revenue in Month 12:</strong> ${monthlyData[11].revenue}</li>
                <li><strong>Cumulative Additional Revenue after 1 year:</strong> ${monthlyData[11].cumulativeRevenue}</li>
                <li><strong>Cumulative Additional Profit after 1 year:</strong> ${monthlyData[11].cumulativeProfit}</li>
                <li><strong>ROI after 1 Year:</strong> ${roi12.toFixed(2)}%</li>
            </ul>
            
            <p><strong>Year 3 Projections:</strong></p>
            <ul>
                <li><strong>Projected Revenue in Month 36:</strong> ${monthlyData[35].revenue}</li>
                <li><strong>Cumulative Additional Revenue after 3 Years:</strong> ${monthlyData[35].cumulativeRevenue}</li>
                <li><strong>Cumulative Additional Profit after 3 Years:</strong> ${monthlyData[35].cumulativeProfit}</li>
                <li><strong>ROI after 3 Years:</strong> ${roi36.toFixed(2)}%</li>
            </ul>
            
            <p><strong>Year 5 Projection:</strong></p>
            <ul>
                <li><strong>Projected Revenue in Month 60:</strong> ${monthlyData[59].revenue}</li>
                <li><strong>Cumulative Additional Revenue after 5 Years:</strong> ${monthlyData[59].cumulativeRevenue}</li>
                <li><strong>Cumulative Additional Profit after 5 Years:</strong> ${monthlyData[59].cumulativeProfit}</li>
                <li><strong>ROI after 5 Years:</strong> ${roi60.toFixed(2)}%</li>
            </ul>
            `;

            // Send report via EmailJS
            emailjs.send('service_f1yxxyh', 'template_tnye1b8', {
                name: clientName,
                email: email,
                business: clientBusiness,
                currency: selectedCurrency,
                revenue: formatCurrency(totalRevenue, selectedCurrency),
                conversion_rate: currentCR + '%',
                average_order_value: formatCurrency(averageOrderValue, selectedCurrency),
                profit_margin: profitRatio + '%',
                breakeven_message: breakevenMessage, // Use calculated breakeven message
                target_monthly_revenue: monthlyData[11].revenue,
                target_conversion_rate: monthlyData[11].cr + '%',
                target_aov: monthlyData[11].aov,
                projected_revenue_12: monthlyData[11].revenue,
                cumulative_additional_revenue_12: monthlyData[11].cumulativeRevenue,
                cumulative_additional_profit_12: monthlyData[11].cumulativeProfit,
                roi12: roi12.toFixed(2) + '%',
                projected_revenue_36: monthlyData[35].revenue,
                cumulative_additional_revenue_36: monthlyData[35].cumulativeRevenue,
                cumulative_additional_profit_36: monthlyData[35].cumulativeProfit,
                roi36: roi36.toFixed(2) + '%',
                projected_revenue_60: monthlyData[59].revenue,
                cumulative_additional_revenue_60: monthlyData[59].cumulativeRevenue,
                cumulative_additional_profit_60: monthlyData[59].cumulativeProfit,
                roi60: roi60.toFixed(2) + '%',
                total_cost_12: formatCurrency(programCost12, selectedCurrency),
                total_cost_36: formatCurrency(programCost36, selectedCurrency),
                total_cost_60: formatCurrency(programCost60, selectedCurrency),
                date: new Date().toLocaleDateString() // Send the current date
            })
            .then(function (response) {
                console.log('SUCCESS!', response.status, response.text);
            }, function (error) {
                console.log('FAILED...', error);
            });

            // Display the report
            document.getElementById('roiReport').innerHTML = reportString;
            document.getElementById('result').style.display = 'block';
            document.getElementById('disclaimer').style.display = 'block';
            document.getElementById('reportCover').style.display = 'none';
        });

        // Helper functions
        function formatCurrency(num, currency) {
            let symbol = '';
            switch (currency) {
                case 'USD':
                    symbol = '$';
                    break;
                case 'EUR':
                    symbol = '€';
                    break;
                case 'GBP':
                    symbol = '£';
                    break;
                case 'AUD':
                    symbol = 'A$';
                    break;
                default:
                    symbol = '';
            }
            return symbol + num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }

        function validateEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(String(email).toLowerCase());
        }
    });

  } catch(e) { console.error(e); }
})();
})();
